var isLw100Personalization = false;
var isAs022Personalization = false;
var isPlaettchenPreviewPersonalization = false;
var isEngravingOnlyPopup = isLw100Personalization || isAs022Personalization;
(function($) {
  var CHAR_MAX_LINE1 = isAs022Personalization ? 12 : 10;
  var CHAR_MAX_LINE2 = 4;
  var SYMBOL_COST = 3;
  var ALLOWED_FONTS = ['G02', 'G04', 'G05', 'G06'];
  var AS022_ALLOWED_FONTS = ['G02', 'G03', 'G04', 'G05', 'G06', 'G07', 'G08'];
  var AS022_G07_ONLY_LAYOUT = '1_zeile';
  var AS022_G07_CHAR_MAX = 8;
  var SIDE_LABELS = ['Vorderseite', 'Rückseite'];
  var sideLayouts = ['1_zeile', '1_zeile'];
  var previewSideCount = 1;
  var physicalSideMap = [0];
  var globalFont = null;
  var fontsCache = null;
  var symbolsCache = null;

  function lw105IsTextOnlyLine(layout, lineNum) {
    if (layout === '1_zeile' && String(lineNum) === '1') return true;
    if (layout === '2_zeilen' && String(lineNum) === '1') return true;
    return false;
  }

  function lw105IsMotivOnlyLine(layout, lineNum) {
    return layout === '2_zeilen' && String(lineNum) === '2';
  }

  function sanitizeLw105TextOnly(value) {
    return normalizeLineTextForFont(String(value || '').replace(/[\r\n]/g, '').replace(/\([^)]*\)/g, ''));
  }

  function setPhysicalSideMap(map) {
    physicalSideMap = Array.isArray(map) && map.length ? map.slice() : [0];
  }

  function getPhysicalSideIndex(uiSideIndex) {
    if (physicalSideMap[uiSideIndex] != null) return physicalSideMap[uiSideIndex];
    return uiSideIndex;
  }

  window.lw043SetPhysicalSideMap = setPhysicalSideMap;

  var LW105_PREVIEW_IMAGES = {
    silver: window.VIV_LW105.bild_lw105_preview_silver_png,
    gold: window.VIV_LW105.bild_lw105_preview_gold_png,
    rosegold: window.VIV_LW105.bild_lw105_preview_rosegold_png,
    silverVorder: window.VIV_LW105.bild_lw105_preview_silver_vorder_png,
    goldVorder: window.VIV_LW105.bild_lw105_preview_gold_vorder_png,
    rosegoldVorder: window.VIV_LW105.bild_lw105_preview_rosegold_vorder_png
  };

  var LW043_SYMBOL_NAMES = {
    'w01.png': 'Mini Herz', 'w02.png': 'Herz', 'w03.png': 'Doppelherz', 'w05.png': 'Infinity',
    'w06.png': 'Fisch', 'w027.png': 'Anker', 'w09.png': 'Engel', 'w041.png': 'Stern'
  };
  var LW105_SYMBOLS_FIXED = [
    { text: 'Mini Herz', image: window.VIV_LW105.bild_w01_png },
    { text: 'Herz', image: window.VIV_LW105.bild_w02_png },
    { text: 'Doppelherz', image: window.VIV_LW105.bild_w03_png },
    { text: 'Infinity', image: window.VIV_LW105.bild_w05_png },
    { text: 'Fisch', image: window.VIV_LW105.bild_w06_png },
    { text: 'Anker', image: window.VIV_LW105.bild_w027_png },
    { text: 'Engel', image: window.VIV_LW105.bild_w09_png },
    { text: 'Stern', image: window.VIV_LW105.bild_w041_png }
  ];
  var LW043_KH_LEGACY = {
    'KH1': 'Mini Herz', 'KH2': 'Herz', 'KH3': 'Doppelherz', 'KH4': 'Infinity',
    'KH5': 'Fisch', 'KH6': 'Anker', 'KH7': 'Engel', 'KH8': 'Stern', 'Pfote': 'Stern'
  };

  /* 双面底图左右分界 50%：左 Vorder / 右 Rück；刻字相对圆牌中心镜像 */
  var LW105_PREVIEW_DISC_CENTER = { front: 25, back: 75 };
  /* Anker je Layout und je Seite - vollstaendig unabhaengig.
     back wurde einmalig aus der frueheren Spiegelung (left -> 100 - left)
     berechnet und fest eingetragen; seitdem wird nichts mehr abgeleitet. */
  var LW105_PREVIEW_1_ZEILE = {
    text: {
      front: { top: 71.5, left: 26.5 },
      back: { top: 71.5, left: 73.5 }
    }
  };
  var LW105_PREVIEW_2_ZEILEN = {
    text: {
      front: { top: 72, left: 26.5 },
      back: { top: 72, left: 73.5 }
    },
    icon: {
      front: { top: 76, left: 26.5 },
      back: { top: 76, left: 73.5 },
      heightEm: 1.43,
      topEm: -0.05
    }
  };
  var LW105_PREVIEW_NUR_MOTIV = {
    icon: {
      front: { top: 73, left: 26.5 },
      back: { top: 73, left: 73.5 },
      heightEm: 1.47,
      topEm: 0
    }
  };

  function mirrorLw105Left(frontLeft) {
    var offset = frontLeft - LW105_PREVIEW_DISC_CENTER.front;
    return Math.round((LW105_PREVIEW_DISC_CENTER.back - offset) * 10) / 10;
  }

  function mirrorLw105PreviewPos(frontPos, sideIndex) {
    if (!frontPos) return { top: 0, left: 0 };
    if (sideIndex === 1) {
      return { top: frontPos.top, left: mirrorLw105Left(frontPos.left) };
    }
    return { top: frontPos.top, left: frontPos.left };
  }

  function getLw105PreviewAnchor(sideIndex, anchorGroup) {
    var pos = anchorGroup && anchorGroup[sideIndex === 1 ? 'back' : 'front'];
    if (!pos) return { top: 0, left: 0 };
    return { top: pos.top, left: pos.left };
  }

  /* ---- Tuner-Konfiguration -------------------------------------------
     Jeder Regler ist eine eigenstaendige Koordinate, getrennt gespeichert nach
     Seite x Layout x Bauteil x Achse x Schrift x Eigenschaft. Nichts wird
     geteilt, abgeleitet oder in den naechsten Regler uebernommen.
     Ein Lesezugriff ohne Treffer liefert den neutralen Standard (0 bzw. den
     Basiswert dieses Elements), niemals den zuletzt bearbeiteten Wert. */
  var LW105_TUNER_FONTS = ['G02', 'G04', 'G05', 'G06'];

  /* [side][layout][font] = { mult, dx, dy } - neutral: 1 / 0 / 0
     Vorbelegt: G04 und G05 sassen in 1 Zeile frueher fest auf top 72 statt
     71.5. Dieser Versatz ist jetzt ein normaler Regler (dy 0.5) und damit
     kalibrierbar - das Rendering bleibt dadurch unveraendert.
     front/2_zeilen: G05 ist noch nicht kalibriert - faellt auf 1.0 zurueck.
     back: konnte nicht kalibriert werden, solange die Option "biedseitig"
     falsch geschrieben ist und das zweiseitige Popup nicht aufgeht; dort
     stehen nur die uebernommenen Altwerte.
     (Hinweise stehen UEBER dem Literal, nicht darin - bake.py schreibt das
     Literal neu und wuerde eingebettete Kommentare verschlucken.) */
  var LW105_TEXT_ADJ = {
    front: {
      '1_zeile': {
        G02: { mult: 1, dx: 0, dy: 0.5 },
        G04: { mult: 1.01, dx: 0, dy: 0.5 },
        G05: { mult: 1, dx: 0, dy: 0.5 },
        G06: { mult: 1, dx: 0, dy: 0.5 }
      },
      '2_zeilen': {
        G02: { mult: 1.06, dx: 0, dy: 0 },
        G04: { mult: 1, dx: 0, dy: 0.2 },
        G06: { mult: 0.89, dx: 0, dy: 0 }
      }
    },
    back: {
      '1_zeile': {
        G04: { mult: 1, dx: 0, dy: 0.5 },
        G05: { mult: 1, dx: 0, dy: 0.5 }
      }
    }
  };
  /* Motiv-Regler pro Seite x Layout x EINZELNEM Symbol.
     size = Hoehe in em, dx/dy = Versatz in Prozent der Vorschau.
     Fehlt ein Eintrag, gilt der Basiswert des Layouts - nie der zuletzt
     bearbeitete Wert eines anderen Symbols.
     Vorbelegt: der frueher fuer ALLE Symbole gemeinsame Wert 1.5 wurde auf
     jedes einzelne Symbol uebertragen, damit sich die Darstellung nicht
     aendert. Ab jetzt ist jedes Symbol einzeln regelbar.
     Stand der Kalibrierung (Hinweise UEBER dem Literal, bake-sicher):
     - nur_motiv: alle acht Symbole einzeln vermessen. Die Spanne von 1.48
       bis 1.80 zeigt, warum ein gemeinsamer Wert nicht funktionieren konnte
       - die Glyphen haben sehr unterschiedlich viel Luft in der Zeichnung.
     - 2_zeilen: bisher nur Herz und Doppelherz vermessen. Die restlichen
       sechs stehen noch auf dem Basiswert 1.43 und sind damit NICHT
       kalibriert. Bewusst nicht aus "Nur Motiv" hochgerechnet: geraten ist
       nicht gemessen, und genau diese Vermischung sollte der Umbau beenden.
     - back: noch kein einziges Symbol kalibriert - siehe TEXT_ADJ. */
  var LW105_SYMBOL_ADJ = {
    front: {
      nur_motiv: {
        'Mini Herz': { size: 1.65, dx: 0, dy: 0.4 },
        Herz: { size: 1.48, dx: 0, dy: 0.4 },
        Doppelherz: { size: 1.5, dx: 0, dy: 0 },
        Infinity: { size: 1.8, dx: 0, dy: 0 },
        Fisch: { size: 1.72, dx: 0, dy: 0 },
        Anker: { size: 1.79, dx: 0, dy: 0 },
        Engel: { size: 1.76, dx: 0, dy: 0 },
        Stern: { size: 1.5, dx: 0, dy: 0 }
      },
      '2_zeilen': {
        Herz: { size: 1.22, dx: 0, dy: 0 },
        Doppelherz: { size: 1.28, dx: 0, dy: 0 }
      }
    }
  };

  /* Abstand zwischen Textzeile und Motivzeile im 2-Zeilen-Layout,
     pro Seite und Schrift. Neutral 0 = bisheriges Verhalten.
     Der Export lieferte fuer front/G02 eine 0, also keinen Eingriff; die
     Tabelle bleibt leer, weil ein leerer Eintrag genau dasselbe bedeutet. */
  var LW105_ROW_GAP = {};

  /* Gesamt-Schicht (G1/G2): wirkt additiv bzw. multiplikativ UEBER den
     einzeln getunten Werten in LW105_SYMBOL_ADJ - niemals als Ersatz.
     motivDx/motivDy in % der Vorschau (gleiche Einheit wie SYMBOL_ADJ.dx/dy),
     motivScale als Faktor auf die einzeln gemessene Hoehe.
     Neutral: 0 / 0 / 1 = Rendering wie vor dem Umbau. */
  var LW105_TUNE = { motivDx: 0, motivDy: 0, motivScale: 1 };

  /* D3: [fontCode][symbolKey] = em-Zuschlag auf den Abstand Text/Motiv im
     2-Zeilen-Layout, zusaetzlich zu LW105_ROW_GAP. Ein breites Motiv braucht
     unter derselben Schrift eine andere Luft als ein schmales. Leer = 0. */
  var LW105_LUFT_ADJ = {};

  function lw105Luft(font, name) {
    return (LW105_LUFT_ADJ[font] || {})[lw105SymbolKey(name)] || 0;
  }

  function lw105TextAdj(side, layout, font) {
    var bySide = LW105_TEXT_ADJ[side];
    var byLayout = bySide && bySide[layout];
    var e = byLayout && byLayout[font];
    return {
      mult: e && e.mult != null ? e.mult : 1,
      dx: e && e.dx != null ? e.dx : 0,
      dy: e && e.dy != null ? e.dy : 0
    };
  }

  function lw105EnsureTextAdj(side, layout, font) {
    if (!LW105_TEXT_ADJ[side]) LW105_TEXT_ADJ[side] = {};
    if (!LW105_TEXT_ADJ[side][layout]) LW105_TEXT_ADJ[side][layout] = {};
    if (!LW105_TEXT_ADJ[side][layout][font]) {
      LW105_TEXT_ADJ[side][layout][font] = { mult: 1, dx: 0, dy: 0 };
    }
    return LW105_TEXT_ADJ[side][layout][font];
  }

  function lw105IconBase(layout) {
    return layout === '2_zeilen' ? LW105_PREVIEW_2_ZEILEN.icon : LW105_PREVIEW_NUR_MOTIV.icon;
  }

  /* Symbolname robust machen: die Vorschau bekommt mal den gespeicherten,
     mal den aufgeloesten Namen. Ohne Symbol wird ein eigener Schluessel
     benutzt, damit "kein Symbol" nicht die Werte eines Symbols ueberschreibt. */
  function lw105SymbolKey(name) {
    var resolved = normalizeStoredSymbol(name) || name;
    return String(resolved || '(ohne)').trim();
  }

  function lw105SymbolAdj(side, layout, name) {
    var base = lw105IconBase(layout);
    var key = lw105SymbolKey(name);
    var bySide = LW105_SYMBOL_ADJ[side];
    var byLayout = bySide && bySide[layout];
    var e = byLayout && byLayout[key];
    return {
      size: e && e.size != null ? e.size : base.heightEm,
      topEm: base.topEm,
      dx: e && e.dx != null ? e.dx : 0,
      dy: e && e.dy != null ? e.dy : 0
    };
  }

  function lw105EnsureSymbolAdj(side, layout, name) {
    var base = lw105IconBase(layout);
    var key = lw105SymbolKey(name);
    if (!LW105_SYMBOL_ADJ[side]) LW105_SYMBOL_ADJ[side] = {};
    if (!LW105_SYMBOL_ADJ[side][layout]) LW105_SYMBOL_ADJ[side][layout] = {};
    if (!LW105_SYMBOL_ADJ[side][layout][key]) {
      LW105_SYMBOL_ADJ[side][layout][key] = { size: base.heightEm, dx: 0, dy: 0 };
    }
    return LW105_SYMBOL_ADJ[side][layout][key];
  }

  function lw105RowGap(side, font) {
    var bySide = LW105_ROW_GAP[side];
    var v = bySide && bySide[font];
    return v != null ? v : 0;
  }

  function lw105EnsureRowGap(side, font) {
    if (!LW105_ROW_GAP[side]) LW105_ROW_GAP[side] = {};
    if (LW105_ROW_GAP[side][font] == null) LW105_ROW_GAP[side][font] = 0;
    return LW105_ROW_GAP[side];
  }

  function lw105CurrentFont() {
    var f = getGlobalFont();
    return (f && f.font_name) || 'G02';
  }

  function lw105IsIconLine(previewMode, lineNum) {
    return previewMode === 'nur_motiv' || (previewMode === '2_zeilen' && lineNum === 2);
  }

  /* G01/G02/G03 haben keine eigene Groessen-Variable und fallen auf die
     Basisvariable zurueck; nur G04/G05/G06 haben eigene Suffixe. */
  function lw105SizeVarName(previewMode, fontCode) {
    var suffix = '';
    if (fontCode === 'G04' || fontCode === 'G05' || fontCode === 'G06') {
      suffix = '-' + fontCode.toLowerCase();
    }
    if (previewMode === 'nur_motiv') return '--lw043-nur-motiv-text-size';
    if (previewMode === '2_zeilen') return '--lw043-2zeilen-text-size' + suffix;
    return '--lw043-1zeile-text-size' + suffix;
  }
  /* dead LW043 branch shims (isPlaettchen/isAs022 false on LW105) */
  var PREVIEW_1_ZEILE = {
    front: LW105_PREVIEW_1_ZEILE.text.front,
    back: mirrorLw105PreviewPos(LW105_PREVIEW_1_ZEILE.text.front, 1)
  };
  var PREVIEW_2_ZEILEN = {
    line1: {
      front: LW105_PREVIEW_2_ZEILEN.text.front,
      back: mirrorLw105PreviewPos(LW105_PREVIEW_2_ZEILEN.text.front, 1)
    },
    line2: {
      front: LW105_PREVIEW_2_ZEILEN.icon.front,
      back: mirrorLw105PreviewPos(LW105_PREVIEW_2_ZEILEN.icon.front, 1)
    }
  };
  var PREVIEW_NUR_MOTIV = {
    front: LW105_PREVIEW_NUR_MOTIV.icon.front,
    back: mirrorLw105PreviewPos(LW105_PREVIEW_NUR_MOTIV.icon.front, 1)
  };
  var LW100_DUAL_1_ZEILE = {
    front: { top: 45, left: 25 },
    back: { top: 45, left: 75.5 }
  };
  /* Wo der Engel im Basisfoto steht — in % der Buehne, GEMESSEN am Foto
     (lw105-preview-*.png, 1600x1600: Rand des nicht-weissen Bereichs je
     Bildhaelfte), nicht geschaetzt. Beide Fotos, ein- wie beidseitig, setzen
     ihn an dieselbe Stelle. Gebraucht wird das nur fuer den Vorschau-Streifen
     auf der Bestaetigungsseite: er schneidet je Flaeche den Engel frei.
     Aendert sich das Foto, muss diese Tabelle neu gemessen werden — sonst
     schneidet der Streifen daneben. */
  /* Am Basisfoto lw105-preview-silver.png (1600x1600) gemessen 2026-09-09: Rand des Anhaengers je
     Bildhaelfte (Zeilen mit >5 % Breite, die duenne Kette zaehlt nicht). */
  var LW105_ENGEL_BOX = {
    top: 50.3, bottom: 88.4, rand: 3,
    front: { left: 14.5, right: 39.1 },
    back: { left: 61.0, right: 85.6 }
  };
  var AS022_PLAETTCHEN_POS = {
    front: { top: 47, left: 25.8 },
    back: { top: 47, left: 74.5 }
  };
  var AS022_2ZEILEN_LINE2 = {
    front: { top: 53, left: 25.8 },
    back: { top: 53, left: 74.5 }
  };
  var AS022_NUR_MOTIV = {
    front: { top: 49, left: 25.8 },
    back: { top: 49, left: 74.5 }
  };
  var AS022_2ZEILEN_ROW_GAP_EXTRA = 1; /* +1% on base line1→line2 gap */
  var AS022_PREVIEW_TEXT_MAX_WIDTH_PCT = 24; /* 384px @ 1600 canvas */
  var PREVIEW_LETTER_ONLY_SCALE = 1.5; /* Phase 1①: letter_only only; not letter_icon */
  var PREVIEW_TEXT_MAX_WIDTH_1600 = 220;
  var PREVIEW_TEXT_MAX_WIDTH_AS022 = 384;

  function getPreviewTextMaxWidthBase() {
    return isAs022Personalization ? PREVIEW_TEXT_MAX_WIDTH_AS022 : PREVIEW_TEXT_MAX_WIDTH_1600;
  }
  var LW043_1ZEILE_ICON_GAP_DEFAULT = '-0.1em';
  var LW043_2ZEILEN_ICON_GAP_DEFAULT = '-0.1em';
  var LW043_1ZEILE_ICON_GAP = {
    'Doppelherz': '0.1em',
    'Infinity': '0.1em',
    'Fisch': '0.1em'
  };
  var LW043_2ZEILEN_ICON_GAP = {
    'Doppelherz': '0.1em',
    'Infinity': '0.1em',
    'Fisch': '0.1em'
  };

  function esc(s) {
    return String(s || '').replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  }

  function imageFileFromUrl(url) {
    return String(url || '').split('/').pop().split('?')[0];
  }

  function normalizeSymbolName(text, imageUrl) {
    var file = imageFileFromUrl(imageUrl);
    if (LW043_SYMBOL_NAMES[file]) return LW043_SYMBOL_NAMES[file];
    if (LW043_KH_LEGACY[text]) return LW043_KH_LEGACY[text];
    return text;
  }

  function normalizeStoredSymbol(name) {
    return name ? (LW043_KH_LEGACY[name] || name) : '';
  }

  function symbolSlug(name) {
    return String(normalizeStoredSymbol(name) || name || '')
      .toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9-]/g, '');
  }

  function getLayoutIconGap(name, previewMode) {
    var key = normalizeStoredSymbol(name) || name;
    var map = previewMode === '2_zeilen' ? LW043_2ZEILEN_ICON_GAP : LW043_1ZEILE_ICON_GAP;
    var fallback = previewMode === '2_zeilen' ? LW043_2ZEILEN_ICON_GAP_DEFAULT : LW043_1ZEILE_ICON_GAP_DEFAULT;
    return Object.prototype.hasOwnProperty.call(map, key) ? map[key] : fallback;
  }

  function loadSymbols() {
    if (symbolsCache) return symbolsCache;
    symbolsCache = LW105_SYMBOLS_FIXED.slice();
    return symbolsCache;
  }

  function loadFonts() {
    if (fontsCache) return fontsCache;
    fontsCache = [];
    $('.product_info_font_json').each(function() {
      try {
        var arr = JSON.parse($(this).html());
        for (var i = 0; i < arr.length; i++) {
          if (isAs022Personalization) {
            if (arr[i] && arr[i].font_name && AS022_ALLOWED_FONTS.indexOf(arr[i].font_name) !== -1) {
              fontsCache.push(arr[i]);
            }
          } else if (ALLOWED_FONTS.indexOf(arr[i].font_name) !== -1) {
            fontsCache.push(arr[i]);
          }
        }
      } catch (e) {}
    });
    if (!isAs022Personalization) {
      ALLOWED_FONTS.forEach(function(code) {
        if (!fontsCache.some(function(f) { return f.font_name === code; })) {
          fontsCache.push({ font_name: code, text: code, image: '' });
        }
      });
      fontsCache.sort(function(a, b) {
        return ALLOWED_FONTS.indexOf(a.font_name) - ALLOWED_FONTS.indexOf(b.font_name);
      });
    } else {
      fontsCache.sort(function(a, b) {
        return AS022_ALLOWED_FONTS.indexOf(a.font_name) - AS022_ALLOWED_FONTS.indexOf(b.font_name);
      });
    }
    return fontsCache;
  }

  function isAs022G07FontAllowed() {
    if (!isAs022Personalization) return true;
    var zu = getActiveSideCount();
    if (zu < 1) return true;
    for (var i = 0; i < zu; i++) {
      if (getSideLayout(i) !== AS022_G07_ONLY_LAYOUT) return false;
    }
    return true;
  }

  function getSelectableFonts() {
    var fonts = loadFonts();
    if (!isAs022Personalization || isAs022G07FontAllowed()) return fonts;
    return fonts.filter(function(f) { return f.font_name !== 'G07'; });
  }

  function ensureAs022GlobalFontForLayout() {
    if (!isAs022Personalization || isAs022G07FontAllowed()) return false;
    if ((getGlobalFont().font_name || '') !== 'G07') return false;
    var fonts = getSelectableFonts();
    globalFont = fonts.length ? fonts[0] : { font_name: 'G02', text: 'NirmalaS' };
    applyFontToInputs();
    return true;
  }

  function getGlobalFont() {
    if (!globalFont) {
      var fonts = loadFonts();
      globalFont = fonts.length ? fonts[0] : { font_name: 'G02', text: 'NirmalaS' };
    }
    return globalFont;
  }

  function getLineMaxLen(lineNum) {
    if (isAs022Personalization && (getGlobalFont().font_name || '') === 'G07' && String(lineNum) !== '2') {
      return AS022_G07_CHAR_MAX;
    }
    return String(lineNum) === '2' ? CHAR_MAX_LINE2 : CHAR_MAX_LINE1;
  }

  var LW043_FONT_STACK = {
    G01: 'MingLiU-ExtB, serif',
    G02: 'NirmalaS, sans-serif',
    G03: '"Time New Man", serif',
    G04: '"Monotype Corsiva", sans-serif',
    G05: '"Bradley Hand ITC", sans-serif',
    G06: '"Murray Hill BT", sans-serif',
    G07: 'Chloe, sans-serif',
    G08: 'fatskinny, sans-serif'
  };

  /* Ergebnis landet in einem HTML-Attribut, das mit doppelten Anfuehrungs-
     zeichen begrenzt ist. Schriftnamen wie "Monotype Corsiva" wuerden das
     Attribut vorzeitig schliessen und alles Nachfolgende verschlucken, also
     werden sie auf einfache Anfuehrungszeichen umgestellt - in CSS
     gleichwertig. */
  function toInlineSafeFontCss(value) {
    return String(value || '').replace(/"/g, "'");
  }

  function getFontFamilyCss() {
    var font = getGlobalFont();
    var code = font.font_name || 'G02';
    if (LW043_FONT_STACK[code]) return toInlineSafeFontCss(LW043_FONT_STACK[code]);
    if (font.text) {
      return toInlineSafeFontCss(font.text.indexOf(',') !== -1 ? font.text : font.text + ', sans-serif');
    }
    return toInlineSafeFontCss(LW043_FONT_STACK.G02);
  }

  function getPreviewFontCodeClass() {
    var code = (getGlobalFont().font_name || 'G02').toLowerCase();
    return ' lw043-preview-font-' + code;
  }

  function isUppercaseOnlyFont() {
    return (getGlobalFont().font_name || 'G02') === 'G08';
  }

  function sanitizeUppercaseLetters(text) {
    return String(text || '').toUpperCase().replace(/[^A-ZÄÖÜẞ0-9.]/g, '');
  }

  function isValidSymbolToken(inner) {
    return !!getSymbolByName(normalizeStoredSymbol(inner)) || !!getSymbolByName(inner);
  }

  function countPreviewLetters(raw) {
    raw = String(raw || '');
    var total = 0, re = /\(([^)]+)\)/g, last = 0, match;
    while ((match = re.exec(raw)) !== null) {
      total += (match.index - last);
      if (!isValidSymbolToken(match[1])) total += match[0].length;
      last = re.lastIndex;
    }
    total += raw.length - last;
    return total;
  }

  function countPreviewIcons(raw) {
    var count = 0, re = /\(([^)]+)\)/g, match;
    raw = String(raw || '');
    while ((match = re.exec(raw)) !== null) {
      if (isValidSymbolToken(match[1])) count++;
    }
    return count;
  }

  function isAs022PreviewLetterOnly(raw, previewMode, symbolOnly, sideClass) {
    if (!isAs022Personalization) return false;
    if (symbolOnly || previewMode === 'nur_motiv') return false;
    if (previewMode !== '1_zeile') return false;
    if (sideClass.indexOf('--front') === -1) return false;
    return countPreviewLetters(raw) === 1 && countPreviewIcons(raw) === 0;
  }

  function getPreviewLetterOnlyClass(raw, previewMode, symbolOnly, sideClass) {
    return isAs022PreviewLetterOnly(raw, previewMode, symbolOnly, sideClass)
      ? ' lw043-preview-text--letter-only' : '';
  }

  function getPreviewLetterOnlyScaleMultiplier(el) {
    if (!el || !el.classList) return 1;
    if (el.classList.contains('lw043-preview-text--letter-only')) return PREVIEW_LETTER_ONLY_SCALE;
    return 1;
  }

  function normalizeG08RawLine(raw) {
    raw = String(raw || '');
    var result = '', re = /\(([^)]*)\)/g, last = 0, match;
    while ((match = re.exec(raw)) !== null) {
      result += sanitizeUppercaseLetters(raw.substring(last, match.index));
      var inner = match[1];
      if (isValidSymbolToken(inner)) {
        var sym = getSymbolByName(normalizeStoredSymbol(inner)) || getSymbolByName(inner);
        result += '(' + sym.text + ')';
      } else {
        result += sanitizeUppercaseLetters(inner);
      }
      last = re.lastIndex;
    }
    result += sanitizeUppercaseLetters(raw.substring(last));
    return result;
  }

  function trimToWeightedMax(str, maxLen) {
    var s = String(str || '');
    while (weightedLength(s) > maxLen && s.length) s = s.slice(0, -1);
    return s.replace(/\([^)]*$/, '');
  }

  function lineHasSymbolAndText(raw) {
    if (!raw) return false;
    var hasSym = false, hasText = false;
    var re = /\(([^)]+)\)/g, last = 0, match;
    while ((match = re.exec(raw)) !== null) {
      if (!isValidSymbolToken(match[1])) continue;
      hasSym = true;
      if (sanitizeUppercaseLetters(raw.substring(last, match.index))) hasText = true;
      last = re.lastIndex;
    }
    if (sanitizeUppercaseLetters(raw.substring(last))) hasText = true;
    return hasSym && hasText;
  }

  function hasInlineSymbolTokens(raw) {
    if (!raw) return false;
    var re = /\(([^)]+)\)/g, match;
    while ((match = re.exec(raw)) !== null) {
      if (!isValidSymbolToken(match[1])) continue;
      if (match.index + match[0].length < raw.length) return true;
    }
    return false;
  }

  function getG08LineRaw($input, sideIndex, lineNum) {
    var raw = normalizeG08RawLine($input.val() || '');
    var storedSym = getLineSymbol(sideIndex, lineNum);
    if (storedSym && !/\([^)]+\)/.test(raw)) raw = composeLine(raw, storedSym);
    return raw;
  }

  function appendOrReplaceTrailingG08Symbol(raw, symName) {
    raw = normalizeG08RawLine(raw || '');
    var token = '(' + normalizeStoredSymbol(symName) + ')';
    var trailing = raw.match(/\(([^)]+)\)$/);
    if (trailing && isValidSymbolToken(trailing[1])) {
      return raw.slice(0, raw.length - trailing[0].length) + token;
    }
    return raw + token;
  }

  function setG08LineRaw($input, sideIndex, lineNum, raw, maxLen) {
    setLineSymbol(sideIndex, lineNum, '');
    raw = trimToWeightedMax(normalizeG08RawLine(raw), maxLen);
    $input.val(raw);
    toggleLineClear($input, raw);
    return raw;
  }

  function normalizeLineTextForFont(text) {
    if (!isUppercaseOnlyFont()) return text || '';
    return sanitizeUppercaseLetters(text);
  }

  function applyFontToInputs() {
    var fontCode = getGlobalFont().font_name || 'G02';
    var fontCss = getFontFamilyCss();
    $('.up-Fenster-p-personalization-1 .lw043-line-input')
      .attr('data-lw043-font', fontCode)
      .css('font-family', fontCss);
  }

  function weightedLength(str) {
    if (!str) return 0;
    var total = 0, re = /\(([^)]+)\)/g, last = 0, match;
    while ((match = re.exec(str)) !== null) {
      total += match.index - last;
      total += SYMBOL_COST;
      last = re.lastIndex;
    }
    total += str.length - last;
    return total;
  }

  function composeLine(text, symbol) {
    return (text || '') + (symbol ? '(' + normalizeStoredSymbol(symbol) + ')' : '');
  }

  function isSymbolOnlyRaw(raw) {
    if (!raw) return false;
    if (isUppercaseOnlyFont()) {
      var normalized = normalizeG08RawLine(raw);
      var only = normalized.match(/^\(([^)]+)\)$/);
      return !!(only && isValidSymbolToken(only[1]));
    }
    var parsed = parseLineValue(raw);
    return !!parsed.symbol && !parsed.text;
  }

  function parseLineValue(raw) {
    var val = raw || '';
    var match = val.match(/\(([^)]+)\)$/);
    if (match) {
      var symName = normalizeStoredSymbol(match[1]);
      if (getSymbolByName(symName) || getSymbolByName(match[1])) {
        return { text: val.substring(0, val.length - match[0].length), symbol: symName };
      }
    }
    return { text: val, symbol: '' };
  }

  function getSymbolByName(name) {
    if (!name) return null;
    var resolved = normalizeStoredSymbol(name);
    var symbols = loadSymbols();
    for (var i = 0; i < symbols.length; i++) {
      if (symbols[i].text === resolved || symbols[i].text === name) return symbols[i];
    }
    return null;
  }

  function getSideIndexFromEl($el) {
    var $side = $el.closest('[class*="product_info_main_"]');
    if (!$side.length) return NaN;
    var match = String($side.attr('class') || '').match(/product_info_main_(\d+)/);
    return match ? parseInt(match[1], 10) : NaN;
  }

  function getSideLabel(index) {
    var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + index);
    var title = $.trim($side.find('.pattles-message-header span').first().text());
    return title || SIDE_LABELS[index] || ('Seite ' + (index + 1));
  }

  function getActiveSideCount() {
    var domCount = $('.up-Fenster-p-personalization-1 [class*="product_info_main_"]').length;
    return domCount > 0 ? domCount : previewSideCount;
  }

  function getColorKeyFromOption1() {
    var label = ($('[name="option1"]').attr('data-value') || '').toLowerCase();
    if (label.indexOf('ros') !== -1) return 'rosegold';
    if (label.indexOf('gold') !== -1 && label.indexOf('ros') === -1) return 'gold';
    return 'silver';
  }

  function getActiveGravurConfig() {
    return window.lw100GravurConfig || window.lw043GravurConfig || window.lwGravurConfig || null;
  }

  function ensureLw043GravurConfig() {
    if (getActiveGravurConfig() || typeof window.lwGravurResolveOption2 !== 'function') {
      return;
    }
    var config = window.lwGravurResolveOption2($('[name="option2"]').attr('data-value') || '');
    if (!config) return;
    window.lwGravurConfig = config;
    if (isEngravingOnlyPopup) {
      window.lw100GravurConfig = config;
    } else {
      window.lw043GravurConfig = config;
    }
  }

  function usesFrontOnlyPreviewBase() {
    ensureLw043GravurConfig();
    var sides = getActiveGravurConfig() && getActiveGravurConfig().physicalSides;
    return Array.isArray(sides) && sides.length === 1 && sides[0] === 0;
  }

  function getColorPreviewUrl() {
    var colorKey = getColorKeyFromOption1();
    if (usesFrontOnlyPreviewBase()) {
      return LW105_PREVIEW_IMAGES[colorKey + 'Vorder']
        || LW105_PREVIEW_IMAGES[colorKey]
        || LW105_PREVIEW_IMAGES.silverVorder
        || LW105_PREVIEW_IMAGES.silver;
    }
    return LW105_PREVIEW_IMAGES[colorKey] || LW105_PREVIEW_IMAGES.silver;
  }

  function getSideLayout(sideIndex) {
    var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + sideIndex);
    return $side.attr('data-lw043-layout') || sideLayouts[sideIndex] || '1_zeile';
  }

  function getLineSymbol(sideIndex, lineNum) {
    var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + sideIndex);
    return normalizeStoredSymbol($side.attr('data-lw043-symbol-line' + lineNum) || '');
  }

  function setLineSymbol(sideIndex, lineNum, sym) {
    $('.up-Fenster-p-personalization-1 .product_info_main_' + sideIndex)
      .attr('data-lw043-symbol-line' + lineNum, normalizeStoredSymbol(sym || ''));
  }

  function getLineInputVal(sideIndex, lineNum) {
    var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + sideIndex);
    var $input = $side.find('.lw043-line-input[data-line="' + lineNum + '"]');
    return $input.length ? ($input.val() || '') : '';
  }

  function getLineParts(sideIndex, lineNum) {
    var layout = getSideLayout(sideIndex);
    if (lw105IsMotivOnlyLine(layout, lineNum)) {
      return { text: '', symbol: getLineSymbol(sideIndex, lineNum) };
    }
    if (lw105IsTextOnlyLine(layout, lineNum)) {
      return { text: sanitizeLw105TextOnly(getLineInputVal(sideIndex, lineNum)), symbol: '' };
    }
    var raw = getLineInputVal(sideIndex, lineNum);
    if (isUppercaseOnlyFont()) {
      raw = normalizeG08RawLine(raw);
      var storedSym = getLineSymbol(sideIndex, lineNum);
      if (storedSym && !/\([^)]+\)/.test(raw)) raw = composeLine(raw, storedSym);
      return { text: raw, symbol: '' };
    }
    var parsed = parseLineValue(raw);
    var symbol = parsed.symbol || getLineSymbol(sideIndex, lineNum);
    return { text: parsed.text, symbol: symbol };
  }

  function toggleLineClear($input, value) {
    var hasContent = !!(value && String(value).trim());
    $input.siblings('.lw043-line-clear').css('display', hasContent ? 'block' : 'none');
  }

  function syncLineInputComposed($input, text, symbol) {
    var composed = composeLine(text, symbol);
    $input.val(composed);
    toggleLineClear($input, composed);
    return composed;
  }

  function getSideData(sideIndex) {
    var layout = getSideLayout(sideIndex);
    var data = { layout: layout, line1: '', line2: '', sym1: '', sym2: '', symOnly: '' };

    if (layout === '1_zeile') {
      var p1 = getLineParts(sideIndex, 1);
      data.line1 = p1.text;
      data.sym1 = p1.symbol;
    } else if (layout === '2_zeilen') {
      var p1b = getLineParts(sideIndex, 1);
      var p2 = getLineParts(sideIndex, 2);
      data.line1 = p1b.text;
      data.line2 = p2.text;
      data.sym1 = p1b.symbol;
      data.sym2 = p2.symbol;
    } else if (layout === 'nur_motiv') {
      var pMotiv = getLineParts(sideIndex, 1);
      data.symOnly = pMotiv.symbol || getLineSymbol(sideIndex, 1);
    }
    return data;
  }

  function sideHasContent(sideIndex) {
    var d = getSideData(sideIndex);
    if (d.layout === 'nur_motiv') return !!d.symOnly;
    if (d.layout === '2_zeilen') {
      return !!(d.line1 && d.sym2);
    }
    if (d.layout === '1_zeile') {
      return !!d.line1;
    }
    return !!composeLine(d.line1, d.sym1);
  }

  function sideHasText(d) {
    if (d.layout === 'nur_motiv') return false;
    if (d.layout === '2_zeilen' || d.layout === '1_zeile') return !!d.line1;
    return !!d.line1;
  }

  function getPreviewMode(d) {
    if (d.layout === 'nur_motiv') return 'nur_motiv';
    if (d.layout === '2_zeilen') return '2_zeilen';
    return '1_zeile';
  }

  function getLw100SinglePos() {
    if (isAs022Personalization) return AS022_PLAETTCHEN_POS.front;
    return { top: 45, left: 25 };
  }

  function getLw100DualPos(sideIndex) {
    if (isAs022Personalization) {
      var as022Pos = sideIndex === 1 ? AS022_PLAETTCHEN_POS.back : AS022_PLAETTCHEN_POS.front;
      return { top: as022Pos.top, left: as022Pos.left };
    }
    var pos = sideIndex === 1 ? LW100_DUAL_1_ZEILE.back : LW100_DUAL_1_ZEILE.front;
    return { top: pos.top, left: pos.left };
  }

  function getAs0222ZeilenLine1Pos(sideIndex) {
    if (usesFrontOnlyPreviewBase()) return AS022_PLAETTCHEN_POS.front;
    return sideIndex === 1 ? AS022_PLAETTCHEN_POS.back : AS022_PLAETTCHEN_POS.front;
  }

  function getAs0222ZeilenLine2Pos(sideIndex) {
    var pos = sideIndex === 1 ? AS022_2ZEILEN_LINE2.back : AS022_2ZEILEN_LINE2.front;
    return { top: pos.top, left: pos.left };
  }

  function getPreviewPos(sideIndex, previewMode, lineNum) {
    if (isPlaettchenPreviewPersonalization) {
      if (previewMode === '2_zeilen' && lineNum === 2) {
        if (isAs022Personalization) {
          return getAs0222ZeilenLine2Pos(sideIndex);
        }
        if (usesFrontOnlyPreviewBase()) {
          return { top: 50, left: 25 };
        }
        var dualLine2Pos = getLw100DualPos(sideIndex);
        return { top: 50, left: dualLine2Pos.left };
      }
      if (previewMode === 'nur_motiv') {
        if (usesFrontOnlyPreviewBase()) {
          if (isAs022Personalization) return AS022_NUR_MOTIV.front;
          return PREVIEW_NUR_MOTIV.front;
        }
        if (isAs022Personalization) {
          var as022Nm = sideIndex === 1 ? AS022_NUR_MOTIV.back : AS022_NUR_MOTIV.front;
          return { top: as022Nm.top, left: as022Nm.left };
        }
        var nm = sideIndex === 1 ? PREVIEW_NUR_MOTIV.back : PREVIEW_NUR_MOTIV.front;
        return { top: nm.top, left: nm.left };
      }
      if (usesFrontOnlyPreviewBase()) {
        return getLw100SinglePos();
      }
      return getLw100DualPos(sideIndex);
    }
    if (previewMode === 'nur_motiv') {
      if (isAs022Personalization) {
        var as022Npos = sideIndex === 1 ? AS022_NUR_MOTIV.back : AS022_NUR_MOTIV.front;
        return { top: as022Npos.top, left: as022Npos.left };
      }
      var nmIcon = getLw105PreviewAnchor(sideIndex, LW105_PREVIEW_NUR_MOTIV.icon);
      return { top: nmIcon.top, left: nmIcon.left };
    }
    if (previewMode === '2_zeilen') {
      if (lineNum === 2) {
        var icon2 = getLw105PreviewAnchor(sideIndex, LW105_PREVIEW_2_ZEILEN.icon);
        return { top: icon2.top, left: icon2.left };
      }
      var text2 = getLw105PreviewAnchor(sideIndex, LW105_PREVIEW_2_ZEILEN.text);
      return { top: text2.top, left: text2.left };
    }
    return getLw1051ZeileTextPos(sideIndex);
  }

  function getLw1051ZeileTextPos(sideIndex) {
    /* Der frühere Sonderfall "G04/G05 auf top 72" steckt jetzt als regulaerer
       Regler in LW105_TEXT_ADJ und wird in buildPreviewStyle addiert. */
    var pos = getLw105PreviewAnchor(sideIndex, LW105_PREVIEW_1_ZEILE.text);
    return { top: pos.top, left: pos.left };
  }

  function getLw105IconStyleVars(previewMode, lineNum, sideKey, symbolName) {
    var side = sideKey || 'front';
    /* G2 multipliziert ueber der einzeln gemessenen Hoehe (D1) - Hoehe statt
       transform, damit die Groesse echt in die Geometrie eingeht. */
    if (previewMode === '2_zeilen' && lineNum === 2) {
      var ic2 = lw105SymbolAdj(side, '2_zeilen', symbolName);
      return '--lw105-icon-height:' + lw105IconHeightEm(ic2.size) + 'em;--lw105-icon-top:' + ic2.topEm + 'em;';
    }
    if (previewMode === 'nur_motiv') {
      var icn = lw105SymbolAdj(side, 'nur_motiv', symbolName);
      return '--lw105-icon-height:' + lw105IconHeightEm(icn.size) + 'em;--lw105-icon-top:' + icn.topEm + 'em;';
    }
    return '';
  }

  function lw105IconHeightEm(size) {
    return Math.round(size * LW105_TUNE.motivScale * 1000) / 1000;
  }

  function buildPreviewStyle(sideIndex, previewMode, lineNum, symbolName) {
    var pos = getPreviewPos(sideIndex, previewMode, lineNum);
    var sideKey = sideIndex === 1 ? 'back' : 'front';
    var fontCode = lw105CurrentFont();
    var iconLine = lw105IsIconLine(previewMode, lineNum);
    var adj = iconLine
      ? lw105SymbolAdj(sideKey, previewMode, symbolName)
      : lw105TextAdj(sideKey, previewMode, fontCode);
    /* G1: alle Motive gemeinsam, additiv UEBER dem Einzelwert (D1). */
    var gDx = iconLine ? LW105_TUNE.motivDx : 0;
    var gDy = iconLine ? LW105_TUNE.motivDy : 0;
    var top = Math.round((pos.top + adj.dy + gDy) * 100) / 100;
    var left = Math.round((pos.left + adj.dx + gDx) * 100) / 100;
    var style = 'top:' + top + '%;left:' + left + '%;font-family:' + getFontFamilyCss() + ';';
    if (!iconLine && adj.mult !== 1) {
      style += 'font-size:calc(var(' + lw105SizeVarName(previewMode, fontCode) + ') * ' + adj.mult + ');';
    }
    if (previewMode === '2_zeilen' && lineNum === 2) {
      /* D3 (Font x Motiv) addiert auf den Zeilenabstand der Schrift. */
      var gap = lw105RowGap(sideKey, fontCode) + lw105Luft(fontCode, symbolName);
      if (gap !== 0) style += '--lw043-2zeilen-line2-margin-top:' + gap + 'em;';
    }
    style += getLw105IconStyleVars(previewMode, lineNum, sideKey, symbolName);
    return style;
  }

  function getPreviewFontClass() {
    var code = getGlobalFont().font_name;
    if (code === 'G04') return ' lw043-preview-text--font-g04';
    if (code === 'G05') return ' lw043-preview-text--font-g05';
    if (code === 'G06') return ' lw043-preview-text--font-g06';
    if (code === 'G07' && isAs022Personalization) return ' lw043-preview-text--font-g07';
    if (code === 'G08' && isAs022Personalization) return ' lw043-preview-text--font-g08';
    return '';
  }

  function isAs022G08MixedLine(raw, previewMode, symbolOnly) {
    if (!isAs022Personalization || previewMode === 'nur_motiv' || symbolOnly) return false;
    if ((getGlobalFont().font_name || 'G02') !== 'G08') return false;
    return lineHasSymbolAndText(raw);
  }

  function isAs022G08SandwichIcon(previewMode, inlineBetween) {
    return isAs022Personalization
      && isUppercaseOnlyFont()
      && previewMode !== 'nur_motiv'
      && (previewMode === '1_zeile' || previewMode === '2_zeilen')
      && inlineBetween;
  }

  function isAs022G03MiniHerzBetween(previewMode, inlineBetween, symText) {
    return isAs022Personalization
      && (getGlobalFont().font_name || 'G02') === 'G03'
      && (previewMode === '1_zeile' || previewMode === '2_zeilen')
      && inlineBetween
      && symbolSlug(symText) === 'mini-herz';
  }

  function getAs022G08MixedFontClass(raw, previewMode, symbolOnly) {
    return isAs022G08MixedLine(raw, previewMode, symbolOnly) ? ' lw043-preview-text--font-g08-mixed' : '';
  }

  function getPreviewTextMaxWidthPx() {
    var stage = $('[data-lw043-preview-stage]')[0];
    if (isAs022Personalization) {
      if (stage && stage.clientWidth) {
        return stage.clientWidth * (AS022_PREVIEW_TEXT_MAX_WIDTH_PCT / 100);
      }
      return PREVIEW_TEXT_MAX_WIDTH_AS022;
    }
    var maxBase = getPreviewTextMaxWidthBase();
    if (!stage || !stage.clientWidth) return maxBase;
    return stage.clientWidth * (maxBase / 1600);
  }

  function fitPreviewTextWidths() {
    var maxW = getPreviewTextMaxWidthPx();
    $('[data-lw043-preview-stage] .lw043-preview-text--1-zeile, [data-lw043-preview-stage] .lw043-preview-text--2-zeilen').each(function() {
      var el = this;
      var contentScale = getPreviewLetterOnlyScaleMultiplier(el);
      el.style.transform = 'translate(-50%, -50%)';
      var w = el.scrollWidth;
      var finalScale = contentScale;
      if (w > 0 && maxW > 0 && w * finalScale > maxW) {
        finalScale = maxW / w;
      }
      if (finalScale !== 1) {
        el.style.transform = 'translate(-50%, -50%) scale(' + finalScale + ')';
      }
    });
  }

  function scheduleFitPreviewTextWidths() {
    requestAnimationFrame(function() {
      fitPreviewTextWidths();
      requestAnimationFrame(fitPreviewTextWidths);
    });
  }

  function getPreviewModeClass(previewMode) {
    if (previewMode === 'nur_motiv') return ' lw043-preview-text--nur-motiv';
    if (previewMode === '2_zeilen') return ' lw043-preview-text--2-zeilen';
    return ' lw043-preview-text--1-zeile';
  }

  function getLw100G02ZeilenSizeMultiplier(weightedLen) {
    var len = Math.max(0, Number(weightedLen) || 0);
    var maxLen = isAs022Personalization ? 12 : 10;
    if (len <= 1) return 1.35;
    if (len >= maxLen) return 0.85;
    if (len <= 3) {
      return 1.35 + ((len - 1) / 2) * (1.0 - 1.35);
    }
    return 1.0 + ((len - 3) / (maxLen - 3)) * (0.85 - 1.0);
  }

  function appendLw100G02ZeilenFontStyle(style, raw, previewMode) {
    if (!isPlaettchenPreviewPersonalization || previewMode !== '2_zeilen') return style;
    if ((getGlobalFont().font_name || 'G02') !== 'G02') return style;
    var mult = getLw100G02ZeilenSizeMultiplier(weightedLength(raw || ''));
    return style + 'font-size:calc(var(--lw043-2zeilen-text-size) * ' + mult + ');';
  }

  function getLw100G02ZeilenDynamicClass(raw, previewMode) {
    if (!isPlaettchenPreviewPersonalization || previewMode !== '2_zeilen') return '';
    if ((getGlobalFont().font_name || 'G02') !== 'G02') return '';
    if (!raw) return '';
    return ' lw100-g02-zeilen-dynamic';
  }

  function getLw100Dual1ZeileClass(sideClass, previewMode) {
    if (!isPlaettchenPreviewPersonalization || usesFrontOnlyPreviewBase() || previewMode !== '1_zeile') {
      return '';
    }
    if (sideClass.indexOf('--front') !== -1) return ' lw100-dual-front-1zeile';
    if (sideClass.indexOf('--back') !== -1) return ' lw100-dual-back-1zeile';
    return '';
  }

  function appendPreviewLine($layers, sideClass, style, raw, previewMode, lineNum) {
    if (!raw) return;
    var modeClass = getPreviewModeClass(previewMode);
    var symbolOnly = previewMode !== 'nur_motiv' && isSymbolOnlyRaw(raw);
    var fontBoostClass = previewMode === 'nur_motiv' || symbolOnly ? '' : getPreviewFontClass();
    var symbolOnlyClass = symbolOnly ? ' lw043-preview-symbol-only' : '';
    var g08MixedFontClass = getAs022G08MixedFontClass(raw, previewMode, symbolOnly);
    var g08MixedTextScale = isAs022G08MixedLine(raw, previewMode, symbolOnly);
    var letterOnlyClass = getPreviewLetterOnlyClass(raw, previewMode, symbolOnly, sideClass);
    var lw100Dual1ZeileClass = getLw100Dual1ZeileClass(sideClass, previewMode);
    var lw100G02ZeilenDynamicClass = getLw100G02ZeilenDynamicClass(raw, previewMode);
    style = appendLw100G02ZeilenFontStyle(style, raw, previewMode);
    var engravingHtml = buildEngravingHtml(raw, previewMode, g08MixedTextScale);
    $layers.append(
      '<div class="lw043-preview-text' + modeClass + sideClass + fontBoostClass + g08MixedFontClass + symbolOnlyClass + letterOnlyClass + lw100Dual1ZeileClass + lw100G02ZeilenDynamicClass + getPreviewFontCodeClass() +
      '" data-lw043-preview-mode="' + previewMode + '" data-lw043-preview-line="' + lineNum + '" style="' + style + '">' +
      engravingHtml + '</div>'
    );
  }

  function buildEngravingHtml(raw, previewMode, g08MixedTextScale) {
    if (!raw) return '';
    var html = '', re = /\(([^)]+)\)/g, last = 0, match;
    var wrapNextAsG03AfterMiniHerz = false;
    function appendTextSegment(text, afterG03MiniHerz) {
      if (!text) return;
      var chunk = esc(text);
      if (g08MixedTextScale) {
        chunk = '<span class="lw043-preview-g08-text-scale">' + chunk + '</span>';
      }
      if (afterG03MiniHerz) {
        chunk = '<span class="lw043-preview-g03-after-mini-herz">' + chunk + '</span>';
      }
      html += chunk;
    }
    while ((match = re.exec(raw)) !== null) {
      if (match.index > last) {
        appendTextSegment(raw.substring(last, match.index), false);
        wrapNextAsG03AfterMiniHerz = false;
      }
      var sym = getSymbolByName(match[1]);
      if (sym && sym.image) {
        var hasTextAfter = re.lastIndex < raw.length;
        var inlineBetween = match.index > 0 && hasTextAfter;
        var sandwichClass = isAs022G08SandwichIcon(previewMode, inlineBetween)
          ? ' lw043-preview-symbol--as022-g08-sandwich'
          : '';
        if (isAs022G03MiniHerzBetween(previewMode, inlineBetween, sym.text)) {
          sandwichClass += ' lw043-preview-symbol--as022-g03-mini-herz-between';
          wrapNextAsG03AfterMiniHerz = true;
        } else {
          wrapNextAsG03AfterMiniHerz = false;
        }
        var gapStyle = previewMode === 'nur_motiv'
          ? ''
          : ' style="margin-left:' + esc(getLayoutIconGap(match[1], previewMode)) + '"';
        html += '<img class="lw043-preview-symbol lw043-preview-symbol--' + esc(symbolSlug(sym.text)) +
          sandwichClass + '"' + gapStyle +
          ' src="' + esc(sym.image) + '" alt="' + esc(match[1]) + '">';
      } else {
        html += esc('(' + match[1] + ')');
        wrapNextAsG03AfterMiniHerz = false;
      }
      last = re.lastIndex;
    }
    if (last < raw.length) appendTextSegment(raw.substring(last), wrapNextAsG03AfterMiniHerz);
    return html;
  }

  function ensurePreviewShell() {
    var $host = $('.up-Fenster-p-personalization-1 .fenster-content-contentin');
    if (!$host.length) return;
    if (!$host.find('.lw043-preview-wrap').length) {
      var shellHtml =
        /* Zweitname lw105-preview-wrap: die FOKUS-Regeln (angepinnte
           Vorschau) haengen daran, damit sie unter dem Vorlagennamen stehen
           und scripts/fokus_status.py sie findet — das Brett liest das
           Praefix aus dem Dateinamen, LW105 rendert aber mit dem
           Familienpraefix lw043. */
        '<div class="lw043-preview-wrap lw105-preview-wrap">' +
          '<div class="lw043-preview-label">Vorschau</div>' +
          '<div class="lw043-preview-stage" data-lw043-preview-stage>' +
            /* NIE loading="lazy" (GOTCHAS 27): das Fenster faehrt von ausserhalb des
               Viewports herein — dort laedt der Browser ein lazy-Bild nicht, und er
               prueft es beim Hereinfahren auch nicht neu. Das Basisbild bliebe grau,
               ohne Fehler in der Konsole (complete=false, naturalWidth 0). Real
               gemessen bei KS017, A203 und A227; Bestand am 2026-09-15 bereinigt. */
            '<img class="lw043-preview-base" alt="">' +
            '<div class="lw043-preview-layers"></div>' +
          '</div>' +
        '</div>';
      $host.prepend(shellHtml);
    }
    if (!$host.find('.lw043-global-font').length) {
      var $fontAnchor = $host.find('.lw043-preview-wrap');
      $fontAnchor.after(
        '<div class="lw043-global-font">' +
          '<div class="lw043-global-font-label">Schriftart</div>' +
          '<div class="lw043-font-grid" data-lw043-font-grid></div>' +
        '</div>'
      );
      renderFontGrid();
    }
  }

  /* ---- Kontext-Schriftart (K530-Standard) ----------------------------------
     docs/KONTEXT-SCHRIFTART-STANDARD.md: die Schriftwahl haengt nicht mehr
     dauerhaft oben, sondern erscheint im Eingabe-Panel — und nur bei
     Gravurstilen, die ueberhaupt Text gravieren. Kriterium ist nicht das Auge,
     sondern ob die Zeile Buchstaben in der globalen Schrift rendert:
     nur_motiv legt ausschliesslich ein Symbolbild ab und bleibt draussen. */
  var LW105_FONT_LAYOUTS = { '1_zeile': 1, '2_zeilen': 1, 'text_oben_motiv_unten': 1 };

  // Anfuehrungszeichen im Stack einfach machen: der Stack landet in einem
  // inline style="…" (GOTCHAS: doppelte Anfuehrungszeichen brechen das Attribut).
  function fontStackForCode(code, fallbackText) {
    var stack = LW043_FONT_STACK[code];
    if (!stack && fallbackText) {
      stack = String(fallbackText).indexOf(',') !== -1 ? fallbackText : fallbackText + ', sans-serif';
    }
    return String(stack || LW043_FONT_STACK.G02).replace(/"/g, "'");
  }

  function renderFontGrid() {
    var fonts = getSelectableFonts();
    var current = getGlobalFont();
    var html = '';
    for (var i = 0; i < fonts.length; i++) {
      var f = fonts[i];
      var active = f.font_name === current.font_name ? ' class="is-active"' : '';
      var probeStyle = 'font-family:' + fontStackForCode(f.font_name, f.text) + ';' +
        (f.font_name === 'G08' ? 'text-transform:uppercase;' : '');
      html += '<button type="button"' + active + ' data-font="' + esc(f.font_name) + '" data-family="' + esc(f.text) + '">' +
        '<span class="lw043-font-probe" style="' + esc(probeStyle) + '">' + esc(f.font_name) + '</span>' +
        '<span class="lw043-font-code">' + esc(f.font_name) + '</span>' +
        '<span class="lw043-font-haken">&#10003;</span>' +
      '</button>';
    }
    $('[data-lw043-font-grid]').html(html);
    syncPanelFontUI();
  }

  /* Jede Probe zeigt IHR EIGENES Kuerzel (Standard 2026-08-15, A184/A189):
     im Raster das Kuerzel der jeweiligen Zeile, im Panel-Kopf das der
     gewaehlten Schrift. Vorher stand hier die Kundeneingabe — vier Zeilen,
     vier Mal derselbe Name. Die Schrift selbst kommt aus dem inline-Style,
     der beim Bauen gesetzt wurde; hier wird nur der Text nachgezogen. */
  function lw043SyncFontProbe() {
    var aktiv = getGlobalFont().font_name || '';
    $('.up-Fenster-p-personalization-1 .lw043-font-probe').each(function() {
      var $btn = $(this).closest('button[data-font]');
      var code = $btn.length ? String($btn.attr('data-font') || '') : aktiv;
      if (code && $(this).text() !== code) $(this).text(code);
    });
  }

  // Kompakte Schrift-Zeile IM Panel. Zugeklappt zeigt der Kopf die aktuelle
  // Schrift als lebende Probe; das Raster klappt erst auf Tipp auf und nach der
  // Wahl wieder zu. Reine Ansicht auf denselben globalFont-Speicher.
  function buildPanelFontRow() {
    var font = getGlobalFont();
    var headStyle = 'font-family:' + fontStackForCode(font.font_name, font.text) + ';';
    return '<div class="lw043-panel-font">' +
      '<button type="button" class="lw043-panel-font-head" aria-expanded="false">' +
        '<span class="lw043-panel-font-title">Schriftart</span>' +
        '<span class="lw043-font-probe" style="' + esc(headStyle) + '">' + esc(font.font_name || '') + '</span>' +
        '<span class="lw043-font-code">' + esc(font.font_name || '') + '</span>' +
        '<span class="lw043-panel-font-chev" aria-hidden="true">&#9662;</span>' +
      '</button>' +
      '<div class="lw043-panel-font-hinweis">Eine Schrift f&uuml;r das ganze Armband &mdash; zum &Auml;ndern tippen.</div>' +
      '<div class="lw043-panel-font-body">' +
        '<div class="lw043-global-font-label">Schriftart w&auml;hlen</div>' +
        '<div class="lw043-font-grid" data-lw043-font-grid></div>' +
      '</div>' +
    '</div>';
  }

  // Alle Panel-Schriftzeilen an den globalen Speicher angleichen. Die Rollen
  // (waehlbar / Spiegel) werden bei JEDEM Lauf nach DOM-Reihenfolge neu
  // vergeben — nach einem Stilwechsel kann die "erste Text-Stelle" auf die
  // andere Seite wandern.
  function syncPanelFontUI() {
    var font = getGlobalFont();
    var stack = fontStackForCode(font.font_name, font.text);
    $('.up-Fenster-p-personalization-1 .lw043-panel-font').each(function(i) {
      var $pf = $(this);
      /* Wird eine Zeile NEU zur Spiegelzeile, faehrt sie zugeklappt ein
         (--zu). Die waehlbare erste Zeile verliert den Zustand immer. */
      var wurdeSpiegel = i > 0 && !$pf.hasClass('lw043-panel-font--spiegel');
      $pf.toggleClass('lw043-panel-font--spiegel', i > 0);
      if (wurdeSpiegel) $pf.addClass('lw043-panel-font--zu');
      if (i === 0) $pf.removeClass('lw043-panel-font--zu');
      if (i > 0 && $pf.hasClass('is-open')) {
        $pf.removeClass('is-open').find('.lw043-panel-font-head').attr('aria-expanded', 'false');
      }
      $pf.find('.lw043-panel-font-head .lw043-font-probe').first().css({
        'font-family': stack,
        'text-transform': font.font_name === 'G08' ? 'uppercase' : 'none'
      });
      $pf.find('.lw043-panel-font-head .lw043-font-code').text(font.font_name || '');
    });
    lw043SyncFontProbe();
  }

  function scrollPanelIntoView($el) {
    var $popup = $('.up-Fenster-p-personalization-1');
    var scrollEl = $popup.find('.fenster-content-inner, .fenster-content-contentin').get(0);
    if (!scrollEl || !$el || !$el.length) return;
    var top = $el[0].getBoundingClientRect().top - scrollEl.getBoundingClientRect().top + scrollEl.scrollTop - 64;
    scrollEl.scrollTop = Math.max(0, top);
  }

  function buildSymbolGrid(sideIndex, lineNum) {
    var symbols = loadSymbols();
    var selected = getLineSymbol(sideIndex, lineNum);
    var html = '<div class="lw043-symbol-grid" data-side="' + sideIndex + '" data-line="' + lineNum + '">';
    for (var i = 0; i < symbols.length; i++) {
      var sym = symbols[i];
      var activeAttr = sym.text === selected ? ' class="is-active"' : '';
      html += '<button type="button"' + activeAttr + ' data-symbol="' + esc(sym.text) + '">' +
        '<img src="' + esc(sym.image) + '" alt="' + esc(sym.text) + '" loading="lazy">' +
        '<span class="lw043-symbol-label">' + esc(sym.text) + '</span></button>';
    }
    return html + '</div>';
  }

  function buildLineField(sideIndex, lineNum, label, options) {
    options = options || {};
    var maxLen = getLineMaxLen(lineNum);
    var symbolHtml = options.textOnly ? '' : buildSymbolGrid(sideIndex, lineNum);
    return '<div class="lw043-line-block" data-line-block="' + lineNum + '">' +
      '<div class="lw043-line-label">' + esc(label) + '</div>' +
      '<div class="lw043-line-input-wrap">' +
        '<input type="text" class="lw043-line-input" data-side="' + sideIndex + '" data-line="' + lineNum + '" data-max="' + maxLen + '">' +
        '<div class="lw043-line-clear" style="display:none"></div>' +
        '<span class="lw043-line-counter"><span class="lw043-count">0</span> / ' + maxLen + '</span>' +
      '</div>' +
      symbolHtml +
    '</div>';
  }

  function buildMotivOnlyField(sideIndex, lineNum, label) {
    return '<div class="lw043-line-block lw043-line-block--motiv-only" data-line-block="' + lineNum + '">' +
      '<div class="lw043-line-label">' + esc(label) + '</div>' +
      '<div class="lw043-line-input-wrap">' +
        '<input type="text" class="lw043-line-input lw043-motiv-display" data-side="' + sideIndex + '" data-line="' + lineNum + '" readonly placeholder="Symbol wählen">' +
        '<div class="lw043-line-clear" style="display:none"></div>' +
      '</div>' +
      buildSymbolGrid(sideIndex, lineNum) +
    '</div>';
  }

  // Huelle um den Panel-Bau: Stile mit Text bekommen die Schrift-Zeile direkt
  // nach dem oeffnenden .lw043-panel-Tag eingeschoben. Einzige Einschubstelle.
  function buildLayoutPanel(sideIndex, layout) {
    var html = buildLayoutPanelCore(sideIndex, layout);
    if (LW105_FONT_LAYOUTS[layout] && html) {
      var cut = html.indexOf('>') + 1;
      html = html.slice(0, cut) + buildPanelFontRow() + html.slice(cut);
    }
    return html;
  }

  function buildLayoutPanelCore(sideIndex, layout) {
    if (layout === '1_zeile') {
      return '<div class="lw043-panel" data-panel="1_zeile">' + buildLineField(sideIndex, 1, '1. ZEILE', { textOnly: true }) + '</div>';
    }
    if (layout === '2_zeilen') {
      return '<div class="lw043-panel" data-panel="2_zeilen">' +
        buildLineField(sideIndex, 1, 'Text oben', { textOnly: true }) +
        buildMotivOnlyField(sideIndex, 2, 'Motiv unten') +
      '</div>';
    }
    return '<div class="lw043-panel" data-panel="nur_motiv">' +
      '<div class="lw043-line-label">Motiv</div>' +
      '<div class="lw043-line-input-wrap">' +
        '<input type="text" class="lw043-line-input lw043-motiv-display" data-side="' + sideIndex + '" data-line="1" readonly placeholder="Symbol wählen">' +
        '<div class="lw043-line-clear" style="display:none"></div>' +
      '</div>' +
      buildSymbolGrid(sideIndex, 1) +
    '</div>';
  }

  function updateLineCounter($input) {
    var lineNum = $input.attr('data-line');
    var maxLen = getLineMaxLen(lineNum);
    $input.attr('data-max', maxLen);
    var idx = getSideIndexFromEl($input);
    var layout = getSideLayout(idx);
    var len;
    if (lw105IsTextOnlyLine(layout, lineNum)) {
      len = sanitizeLw105TextOnly($input.val()).length;
    } else if (isUppercaseOnlyFont()) {
      len = weightedLength(getG08LineRaw($input, idx, lineNum));
    } else {
      var parsed = parseLineValue($input.val() || '');
      var sym = parsed.symbol || getLineSymbol(idx, lineNum);
      len = weightedLength(composeLine(parsed.text, sym));
    }
    $input.closest('.lw043-line-block').find('.lw043-count').text(len);
    $input.closest('.lw043-line-input-wrap').find('.lw043-line-counter').html('<span class="lw043-count">' + len + '</span> / ' + maxLen);
    toggleLineClear($input, $input.val());
  }

  function applyLineLimitsForFont() {
    $('.lw043-line-input:not([readonly])').each(function() {
      var $input = $(this);
      var idx = getSideIndexFromEl($input);
      var lineNum = $input.attr('data-line');
      var maxLen = getLineMaxLen(lineNum);
      var layout = getSideLayout(idx);
      if (lw105IsTextOnlyLine(layout, lineNum)) {
        setLineSymbol(idx, lineNum, '');
        var plainText = sanitizeLw105TextOnly($input.val());
        while (plainText.length > maxLen) plainText = plainText.slice(0, -1);
        $input.val(plainText);
        toggleLineClear($input, plainText);
        updateLineCounter($input);
        return;
      }
      if (isUppercaseOnlyFont()) {
        setG08LineRaw($input, idx, lineNum, getG08LineRaw($input, idx, lineNum), maxLen);
        syncSymbolGridForLine(idx, lineNum);
        updateLineCounter($input);
        return;
      }
      var parsed = parseLineValue($input.val() || '');
      var symbol = parsed.symbol || getLineSymbol(idx, lineNum);
      var text = normalizeLineTextForFont(parsed.text);
      while (weightedLength(composeLine(text, symbol)) > maxLen && text.length) {
        text = text.slice(0, -1);
      }
      if (symbol && weightedLength(composeLine(text, symbol)) > maxLen) {
        symbol = '';
      }
      setLineSymbol(idx, lineNum, symbol);
      syncLineInputComposed($input, text, symbol);
      syncSymbolGridForLine(idx, lineNum);
      updateLineCounter($input);
    });
  }

  function syncSymbolGridForLine(sideIndex, lineNum) {
    var selected = getLineSymbol(sideIndex, lineNum);
    if (!selected && isUppercaseOnlyFont()) {
      var raw = normalizeG08RawLine(getLineInputVal(sideIndex, lineNum));
      if (!hasInlineSymbolTokens(raw)) {
        var trailing = raw.match(/\(([^)]+)\)$/);
        if (trailing && isValidSymbolToken(trailing[1])) {
          selected = normalizeStoredSymbol(trailing[1]);
        }
      }
    }
    var $grid = $('.product_info_main_' + sideIndex).find('.lw043-symbol-grid[data-line="' + lineNum + '"]');
    $grid.find('button').removeClass('is-active');
    if (selected) $grid.find('button[data-symbol="' + selected + '"]').addClass('is-active');
  }

  function setSideLayout(sideIndex, layout) {
    sideLayouts[sideIndex] = layout;
    var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + sideIndex);
    $side.attr('data-lw043-layout', layout);
    $side.find('.lw043-layout-switch button').removeClass('is-active');
    $side.find('.lw043-layout-switch button[data-layout="' + layout + '"]').addClass('is-active');
    $side.find('.lw043-dynamic').html(buildLayoutPanel(sideIndex, layout));
    // Immer neu rendern: das frisch gebaute Panel bringt ein leeres
    // Schrift-Raster mit, und renderFontGrid vergibt ueber syncPanelFontUI
    // gleich die Rollen (waehlbar / Spiegel) neu.
    ensureAs022GlobalFontForLayout();
    renderFontGrid();
    applyFontToInputs();
    $side.removeClass('has-error');
    $side.find('.lw043-side-error').hide();
    window.lw043UpdatePreview();
  }

  /* [1] Nach jeder Wahl: aktive Karte sichtbar halten und mit Nachbarn auf
     drei auffuellen. Sortiert wird per CSS (order:-1), die DOM-Reihenfolge
     bleibt (K530-Regel). */
  function lw105SyncLayoutCollapse($scope) {
    ($scope && $scope.length ? $scope : $('.up-Fenster-p-personalization-1'))
      .find('.lw043-layout-switch').each(function() {
        var $row = $(this);
        var $more = $row.next('.lw043-layout-more');
        var $chips = $row.find('button[data-layout]');
        if (!$row.hasClass('is-collapsed')) {
          $chips.addClass('lw043-chip-visible');
          if ($more.length) $more.html('Weniger Gravur-Arten &#9652;');
          return;
        }
        var $aktiv = $chips.filter('.is-active');
        $chips.removeClass('lw043-chip-visible');
        $aktiv.addClass('lw043-chip-visible');
        $chips.not($aktiv).slice(0, $aktiv.length ? 2 : 3).addClass('lw043-chip-visible');
        if ($more.length) {
          $more.html('Weitere Gravur-Arten (' + ($chips.length - 3) + ') &#9662;');
        }
      });
  }

  function setupSide(sideIndex) {
    var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + sideIndex);
    if (!$side.length) return;
    $side.find('.pattles-tab-header').hide();

    if (!$side.find('.lw043-layout-switch').length) {
      $side.find('.pattles-message-header').after(
        '<div class="lw043-layout-switch lw043-layout-switch--lw105">' +
          '<button type="button" class="is-active" data-layout="1_zeile">1 Zeile</button>' +
          '<button type="button" data-layout="2_zeilen">Text oben motiv unten</button>' +
          '<button type="button" data-layout="nur_motiv">Nur Motiv</button>' +
        '</div>' +
        '<div class="lw043-dynamic"></div>' +
        '<p class="lw043-side-error">Bitte fülle die Gravur für diese Seite aus.</p>'
      );
    }
    setSideLayout(sideIndex, sideLayouts[sideIndex] || '1_zeile');
  }

  function renderAllPreviewEngravings() {
    var $layers = $('[data-lw043-preview-stage] .lw043-preview-layers');
    $layers.empty();
    var zu = getActiveSideCount();

    for (var i = 0; i < zu; i++) {
      var d = getSideData(i);
      var previewMode = getPreviewMode(d);
      var physicalSide = getPhysicalSideIndex(i);
      var sideClass = physicalSide === 1 ? ' lw043-preview-text--back' : ' lw043-preview-text--front';

      if (d.layout === '2_zeilen') {
        var c1 = d.line1 || '';
        var c2 = d.sym2 ? composeLine('', d.sym2) : '';
        if (!c1 && !c2) continue;
        if (c1 && c2) {
          appendPreviewLine($layers, sideClass, buildPreviewStyle(physicalSide, previewMode, 1), c1, previewMode, 1);
          appendPreviewLine($layers, sideClass + ' lw043-preview-line2 lw043-preview-text--lw105-icon-only', buildPreviewStyle(physicalSide, previewMode, 2, d.sym2), c2, previewMode, 2);
          continue;
        }
        if (c1) appendPreviewLine($layers, sideClass, buildPreviewStyle(physicalSide, previewMode, 1), c1, previewMode, 1);
        else appendPreviewLine($layers, sideClass + ' lw043-preview-line2 lw043-preview-text--lw105-icon-only', buildPreviewStyle(physicalSide, previewMode, 2, d.sym2), c2, previewMode, 2);
        continue;
      }

      if (d.layout === 'nur_motiv') {
        appendPreviewLine($layers, sideClass + ' lw043-preview-text--lw105-icon-only', buildPreviewStyle(physicalSide, previewMode, 1, d.symOnly), composeLine('', d.symOnly), previewMode, 1);
        continue;
      }

      var raw = d.layout === '1_zeile' ? d.line1 : composeLine(d.line1, d.sym1);
      appendPreviewLine($layers, sideClass, buildPreviewStyle(physicalSide, previewMode, 1), raw, previewMode, 1);
    }
    scheduleFitPreviewTextWidths();
    $layers.find('.lw043-preview-text img').off('load.lw043Fit').on('load.lw043Fit', fitPreviewTextWidths);
    if ($layers.find('.lw043-preview-text img').filter(function() { return this.complete; }).length) {
      fitPreviewTextWidths();
    }
  }

  window.lw043UpdatePreview = function() {
    /* Ohne diesen Refresh bleibt der Kontext-Teil des Panels beim ersten
       Zustand stehen (A184-Lektion). */
    if (window.VivTuner) VivTuner.refresh('lw105');
    ensurePreviewShell();
    var baseUrl = getColorPreviewUrl();
    var $stage = $('[data-lw043-preview-stage]');
    $stage.find('.lw043-preview-base').attr('src', baseUrl);
    renderAllPreviewEngravings();
  };

  function bindEvents() {
    var $popup = $('.up-Fenster-p-personalization-1');

    $popup.off('click.lw043Layout', '.lw043-layout-switch button').on('click.lw043Layout', '.lw043-layout-switch button', function() {
      var $row = $(this).closest('.lw043-layout-switch');
      if ($(this).hasClass('is-active')) {
        /* [1] Tipp auf die schon aktive Karte: nur wieder zuklappen */
        $row.addClass('is-collapsed');
        lw105SyncLayoutCollapse($row.parent());
        return;
      }
      var idx = getSideIndexFromEl($(this));
      if (isNaN(idx)) return;
      /* [1] Nach der Wahl faltet die Liste wieder zu (K530-Verhalten) */
      $row.addClass('is-collapsed');
      setSideLayout(idx, $(this).data('layout'));
      lw105SyncLayoutCollapse($row.parent());
    });

    $popup.off('click.lw105More', '.lw043-layout-more').on('click.lw105More', '.lw043-layout-more', function() {
      $(this).prev('.lw043-layout-switch').toggleClass('is-collapsed');
      lw105SyncLayoutCollapse($(this).parent());
    });

    $popup.off('click.lw043Font', '[data-lw043-font-grid] button').on('click.lw043Font', '[data-lw043-font-grid] button', function() {
      var $pf = $(this).closest('.lw043-panel-font');
      globalFont = { font_name: $(this).data('font'), text: $(this).data('family') };
      renderFontGrid();
      if ($pf.length) {
        $pf.removeClass('is-open').find('.lw043-panel-font-head').attr('aria-expanded', 'false');
      }
      applyFontToInputs();
      applyLineLimitsForFont();
      window.lw043UpdatePreview();
    });

    $popup.off('click.lw043PanelFont', '.lw043-panel-font-head').on('click.lw043PanelFont', '.lw043-panel-font-head', function() {
      var $pf = $(this).closest('.lw043-panel-font');
      if ($pf.hasClass('lw043-panel-font--spiegel')) {
        // Zugeklappter Spiegel: erster Tipp zeigt nur den Hinweis.
        if ($pf.hasClass('lw043-panel-font--zu')) {
          $pf.removeClass('lw043-panel-font--zu');
          return;
        }
        // Spiegel-Zeile klappt nicht sich selbst auf, sondern springt zur
        // einzigen waehlbaren Zeile und oeffnet die.
        var $primary = $popup.find('.lw043-panel-font').not('.lw043-panel-font--spiegel').first();
        if (!$primary.length) return;
        /* Die waehlbare Zeile kann auf der zugeklappten Gravurflaeche liegen
           ([3] Akkordeon) — dann erst deren Kopf aufklappen, sonst springt
           der Blick auf etwas Unsichtbares. */
        var $pSide = $primary.closest('[class*="product_info_main_"]');
        if ($pSide.length && $pSide.hasClass('lw105-side--klappbar') && !$pSide.hasClass('is-side-open')) {
          var treffer = String($pSide.attr('class') || '').match(/product_info_main_(\d+)/);
          if (treffer) lw105OpenSide(parseInt(treffer[1], 10), false);
        }
        $primary.addClass('is-open').find('.lw043-panel-font-head').attr('aria-expanded', 'true');
        scrollPanelIntoView($primary);
        return;
      }
      var open = !$pf.hasClass('is-open');
      $pf.toggleClass('is-open', open);
      $(this).attr('aria-expanded', open ? 'true' : 'false');
    });

    // Tipp auf den Hinweis wirkt wie ein Tipp auf den Kopf (2. Tipp = Sprung).
    $popup.off('click.lw043PanelFontHinweis', '.lw043-panel-font--spiegel .lw043-panel-font-hinweis')
      .on('click.lw043PanelFontHinweis', '.lw043-panel-font--spiegel .lw043-panel-font-hinweis', function() {
        $(this).closest('.lw043-panel-font').find('.lw043-panel-font-head').trigger('click');
      });

    $popup.off('input.lw043Line', '.lw043-line-input:not([readonly])').on('input.lw043Line', '.lw043-line-input:not([readonly])', function() {
      var $input = $(this);
      var idx = getSideIndexFromEl($input);
      var lineNum = $input.attr('data-line');
      var maxLen = getLineMaxLen(lineNum);
      var layout = getSideLayout(idx);
      if (lw105IsTextOnlyLine(layout, lineNum)) {
        setLineSymbol(idx, lineNum, '');
        var textOnly = sanitizeLw105TextOnly($input.val());
        while (textOnly.length > maxLen) textOnly = textOnly.slice(0, -1);
        $input.val(textOnly);
        toggleLineClear($input, textOnly);
        updateLineCounter($input);
        window.lw043UpdatePreview();
        return;
      }
      if (isUppercaseOnlyFont()) {
        setG08LineRaw($input, idx, lineNum, $input.val(), maxLen);
        syncSymbolGridForLine(idx, lineNum);
        updateLineCounter($input);
        window.lw043UpdatePreview();
        return;
      }
      var parsed = parseLineValue(($input.val() || '').replace(/[\r\n]/g, ''));
      setLineSymbol(idx, lineNum, parsed.symbol);
      var text = normalizeLineTextForFont(parsed.text);
      var symbol = parsed.symbol || getLineSymbol(idx, lineNum);
      while (weightedLength(composeLine(text, symbol)) > maxLen && text.length) {
        text = text.slice(0, -1);
      }
      syncLineInputComposed($input, text, symbol);
      syncSymbolGridForLine(idx, lineNum);
      updateLineCounter($input);
      window.lw043UpdatePreview();
    });

    $popup.off('click.lw043Symbol', '.lw043-symbol-grid button').on('click.lw043Symbol', '.lw043-symbol-grid button', function() {
      var $grid = $(this).closest('.lw043-symbol-grid');
      var idx = parseInt($grid.attr('data-side'), 10);
      var lineNum = $grid.attr('data-line');
      var symName = normalizeStoredSymbol($(this).data('symbol'));
      var layout = getSideLayout(idx);
      var maxLen = getLineMaxLen(lineNum);

      if (layout === 'nur_motiv' || lw105IsMotivOnlyLine(layout, lineNum)) {
        setLineSymbol(idx, lineNum, symName);
        syncSymbolGridForLine(idx, lineNum);
        var $display = $('.product_info_main_' + idx).find('.lw043-motiv-display[data-line="' + lineNum + '"]');
        syncLineInputComposed($display, '', symName);
        window.lw043UpdatePreview();
        return;
      }

      if (lw105IsTextOnlyLine(layout, lineNum)) {
        return;
      }

      var $input = $('.product_info_main_' + idx).find('.lw043-line-input[data-line="' + lineNum + '"]');
      if (isUppercaseOnlyFont()) {
        var g08Raw = getG08LineRaw($input, idx, lineNum);
        var g08Next = appendOrReplaceTrailingG08Symbol(g08Raw, symName);
        if (weightedLength(g08Next) > maxLen) return;
        setG08LineRaw($input, idx, lineNum, g08Next, maxLen);
        syncSymbolGridForLine(idx, lineNum);
        updateLineCounter($input);
        window.lw043UpdatePreview();
        return;
      }

      var parsed = parseLineValue($input.val() || '');
      if (weightedLength(composeLine(parsed.text, symName)) > maxLen) return;

      setLineSymbol(idx, lineNum, symName);
      syncLineInputComposed($input, parsed.text, symName);
      syncSymbolGridForLine(idx, lineNum);
      updateLineCounter($input);
      window.lw043UpdatePreview();
    });

    $popup.off('click.lw043Clear', '.lw043-line-clear').on('click.lw043Clear', '.lw043-line-clear', function() {
      var $input = $(this).siblings('.lw043-line-input');
      var idx = getSideIndexFromEl($input);
      var lineNum = $input.attr('data-line') || '1';
      setLineSymbol(idx, lineNum, '');
      $input.val('');
      toggleLineClear($input, '');
      syncSymbolGridForLine(idx, lineNum);
      if ($input.attr('data-max')) updateLineCounter($input);
      window.lw043UpdatePreview();
    });

    if (!window._lw043PreviewFitResize) {
      window._lw043PreviewFitResize = true;
      $(window).on('resize.lw043PreviewFit', fitPreviewTextWidths);
    }
  }

  /* ==================================================================
     FOKUS — K530-Anzeigestandard (Yin 2026-08-16). Vorbild: lw042, gleiche
     Familie, ebenfalls genau EINE Buehne fuer alle Gravurflaechen. Nur
     Darstellung und Bedienung; die Bestell-Eigenschaften bleiben Zeichen
     fuer Zeichen unveraendert.
     ================================================================== */

  function lw105SideEl(index) {
    return $('.up-Fenster-p-personalization-1 .product_info_main_' + index);
  }

  function lw105AlleSeiten() {
    return $('.up-Fenster-p-personalization-1 [class*="product_info_main_"]');
  }

  function lw105ScrollEl() {
    return $('.up-Fenster-p-personalization-1')
      .find('.fenster-content-inner, .fenster-content-contentin').get(0);
  }

  /* [5] Solange die Vorschau am Handy angepinnt ist, weicht sie beim
     Runterscrollen aus (die Kundin ist auf dem Weg zur naechsten Flaeche)
     und kommt beim Hochscrollen oder beim Tippen sofort zurueck. */

  function lw105ScrollPolster(scrollEl) {
    return parseFloat((window.getComputedStyle(scrollEl) || {}).paddingTop) || 0;
  }  /* Programmatische Spruenge duerfen nichts verstecken: 600 ms Sperre und
     die Vorschau vorher zurueckholen. Der Versatz zieht die angepinnte
     Vorschau ab, damit der Seitenkopf nicht dahinter verschwindet — am
     Desktop ist sie nicht sticky, dann ist der Versatz null. */
  function lw105ScrollSideIntoView($side) {
    var scrollEl = lw105ScrollEl();
    if (!scrollEl || !$side || !$side.length) return;
    var versatz = 8;
    var $pv = $('.lw043-preview-wrap').first();
    if ($pv.length && $pv.css('position') === 'sticky') {
      versatz += ($pv.outerHeight() || 0) + lw105ScrollPolster(scrollEl);
    }
    var top = $side[0].getBoundingClientRect().top
      - scrollEl.getBoundingClientRect().top + scrollEl.scrollTop - versatz;
    scrollEl.scrollTop = Math.max(0, top);
  }

  /* [3] Seiten-Akkordeon: nur bei zwei Gravurflaechen, dann ist immer genau
     eine offen. Der Zustand ueberlebt den Neuaufbau des Popups. */
  var lw105OffeneSeite = 0;

  function lw105EnsureChevron($side) {
    var $head = $side.children('.pattles-message-header');
    /* Der Titel-<span> bleibt das ERSTE Kind — getSideLabel liest ihn per
       .first(), das Chevron haengt dahinter. */
    if ($head.length && !$head.children('.lw105-side-chev').length) {
      $head.append('<span class="lw105-side-chev" aria-hidden="true">&#9662;</span>');
    }
  }

  function lw105OpenSide(index, scrollen) {
    var $sides = lw105AlleSeiten();
    if (!$sides.filter('.lw105-side--klappbar').length) return;
    lw105OffeneSeite = index;
    $sides.removeClass('is-side-open');
    var $ziel = lw105SideEl(index).addClass('is-side-open');
    if (scrollen) lw105ScrollSideIntoView($ziel);
  }

  function lw105ApplyAkkordeon(zu) {
    var $sides = lw105AlleSeiten();
    if (zu < 2) {
      /* Eine Flaeche: kein Akkordeon — die Klasse wegnehmen, damit die
         Zuklapp-Regeln nichts verstecken koennen. */
      $sides.removeClass('lw105-side--klappbar').addClass('is-side-open');
      return;
    }
    $sides.addClass('lw105-side--klappbar').each(function() {
      lw105EnsureChevron($(this));
    });
    var ziel = (lw105OffeneSeite >= 0 && lw105OffeneSeite < zu) ? lw105OffeneSeite : 0;
    $sides.removeClass('is-side-open');
    lw105SideEl(ziel).addClass('is-side-open');
    lw105OffeneSeite = ziel;
  }

  function lw105BindAkkordeon() {
    var $popup = $('.up-Fenster-p-personalization-1');
    /* [3] Kopfzeile klappt ihre Seite auf; die andere geht dabei zu. */
    $popup.off('click.lw105Side', '.lw105-side--klappbar > .pattles-message-header')
      .on('click.lw105Side', '.lw105-side--klappbar > .pattles-message-header', function() {
        var $side = $(this).parent();
        if ($side.hasClass('is-side-open')) return;
        var treffer = String($side.attr('class') || '').match(/product_info_main_(\d+)/);
        if (!treffer) return;
        lw105OpenSide(parseInt(treffer[1], 10), true);
      });
  }

  window.lw043ValidateBeforeOpen = function() {
    return true;
  };

  window.lw043AfterUpdateSize = function(zu) {
    var gravurConfig = getActiveGravurConfig();
    if (gravurConfig && gravurConfig.physicalSides) {
      setPhysicalSideMap(gravurConfig.physicalSides);
    } else {
      var parsedZu = parseInt(zu, 10) || 0;
      var defaultMap = [];
      for (var mapIndex = 0; mapIndex < parsedZu; mapIndex++) defaultMap.push(mapIndex);
      setPhysicalSideMap(defaultMap);
    }

    zu = parseInt(zu, 10) || 0;
    if (zu < 1) {
      return;
    }
    zu = Math.min(zu, 2);
    previewSideCount = zu;
    ensurePreviewShell();
    for (var i = 0; i < zu; i++) setupSide(i);
    ensureAs022GlobalFontForLayout();
    renderFontGrid();
    applyFontToInputs();
    bindEvents();
    lw105ApplyAkkordeon(zu);
    lw105BindAkkordeon();
    window.lw043UpdatePreview();
  };

  window.lw043OnPopupOpen = function() {
    symbolsCache = null;
    fontsCache = null;
    if (window.lw043RefreshPopupSides) lw043RefreshPopupSides();
    ensurePreviewShell();
    previewSideCount = $('.up-Fenster-p-personalization-1 [class*="product_info_main_"]').length || previewSideCount;
    if (window.lw043AfterUpdateSize) lw043AfterUpdateSize(previewSideCount);
    else { bindEvents(); window.lw043UpdatePreview(); }
  };

  window.lw043OnPopupClose = function() {
    $('.product-info--lw043 [class*="product_info_main_"]').removeClass('has-error');
  };

  window.lw043ValidateSides = function(zu) {
    zu = Math.min(Math.max(parseInt(zu, 10) || 1, 1), 2);
    var valid = true;
    var ersteFehlerSeite = -1;
    for (var i = 0; i < zu; i++) {
      var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + i);
      $side.removeClass('has-error');
      $side.find('.lw043-side-error').hide();
      if (!sideHasContent(i)) {
        valid = false;
        $side.addClass('has-error');
        $side.find('.lw043-side-error').show();
        if (ersteFehlerSeite < 0) ersteFehlerSeite = i;
      }
    }
    if (!valid) {
      /* [6] Fokus-Regel: nur die ERSTE fehlerhafte Flaeche aufklappen und
         anspringen. Weitere fehlerhafte Flaechen tragen am zugeklappten Kopf
         ein rotes „!" und kommen beim naechsten Klick der Reihe nach dran. */
      if (ersteFehlerSeite >= 0) lw105OpenSide(ersteFehlerSeite, false);
      alert('Bitte fülle die Gravur für jede Seite aus.');
      if (ersteFehlerSeite >= 0) lw105ScrollSideIntoView(lw105SideEl(ersteFehlerSeite));
    }
    return valid;
  };

  function formatLw105SymbolFileCode(imageUrl) {
    var base = imageFileFromUrl(imageUrl).replace(/\.png$/i, '');
    if (/^w/i.test(base)) base = 'W' + base.slice(1);
    return '(' + base + ')';
  }

  function formatLw105SymbolOrderValue(symName) {
    var parsed = parseLineValue(symName || '');
    var resolved = normalizeStoredSymbol(parsed.symbol || symName) || symName;
    var sym = getSymbolByName(resolved);
    if (!sym || !sym.image) return '(' + resolved + ')';
    return (sym.text || resolved) + ' ' + formatLw105SymbolFileCode(sym.image);
  }

  function formatLw105ComposedOrderValue(line1, sym1) {
    if (!sym1) return line1 || '';
    var symValue = formatLw105SymbolOrderValue(sym1);
    var text = line1 || '';
    return text ? (text + ' ' + symValue) : symValue;
  }

  window.lw043AppendSideProperties = function(properies_arr, zu, popup_title) {
    var fontName = getGlobalFont().font_name;
    for (var i = 0; i < zu; i++) {
      var title = getSideLabel(i);
      if (popup_title) {
        var parts = String(popup_title).split(',');
        if (parts[i]) title = $.trim(parts[i]);
      }
      var d = getSideData(i);
      if (d.layout === 'nur_motiv' && d.symOnly) {
        properies_arr.push([title + ' SYMBOL', formatLw105SymbolOrderValue(d.symOnly)]);
        continue;
      }
      if (d.layout === '2_zeilen') {
        if (d.line1) properies_arr.push([title + ' 1 ZEILEN', d.line1]);
        if (d.sym2) properies_arr.push([title + ' 2 ZEILE', formatLw105SymbolOrderValue(d.sym2)]);
        if (sideHasText(d)) properies_arr.push([title + ' Font', fontName]);
        continue;
      }
      if (d.layout === '1_zeile' && d.line1) {
        properies_arr.push([title + ' Text', d.line1]);
        properies_arr.push([title + ' Font', fontName]);
        continue;
      }
      var composed = formatLw105ComposedOrderValue(d.line1, d.sym1);
      if (composed) {
        properies_arr.push([title + ' Text', composed]);
        if (sideHasText(d)) properies_arr.push([title + ' Font', fontName]);
      }
    }
  };

  function lw105ConfirmRow(template, optionName, optionValue) {
    if (optionValue === undefined || optionValue === null || String(optionValue).trim() === '') return '';
    return template.replaceAll('{option_name}', optionName).replaceAll('{option_value}', optionValue);
  }

  function formatLw105SymbolConfirmValue(symName) {
    var parsed = parseLineValue(symName || '');
    var resolved = normalizeStoredSymbol(parsed.symbol || symName) || symName;
    var sym = getSymbolByName(resolved);
    if (!sym || !sym.image) {
      return esc(resolved) + ' (' + esc(String(resolved).toUpperCase()) + ')';
    }
    var displayName = sym.text || resolved;
    var fileCode = formatLw105SymbolFileCode(sym.image);
    return '<span class="lw105-confirm-symbol-wrap">' +
      '<span class="lw105-confirm-symbol-name">' + esc(displayName) + '</span>' +
      '<img class="lw105-confirm-symbol" src="' + esc(sym.image) + '" alt="' + esc(displayName) + '">' +
      '<span class="lw105-confirm-symbol-code">' + esc(fileCode) + '</span></span>';
  }

  function shouldLw105AppendFontAfterSide(sideIndex, zu, d) {
    if (!sideHasText(d)) return false;
    if (getPhysicalSideIndex(sideIndex) === 0) return true;
    return zu === 1;
  }

  function buildLw105SideConfirmHtml(template, title, d, fontName, sideIndex, zu) {
    var html = '';
    if (d.layout === 'nur_motiv' && d.symOnly) {
      html += lw105ConfirmRow(template, title + ' SYMBOL', formatLw105SymbolConfirmValue(d.symOnly));
      return html;
    }
    if (d.layout === '2_zeilen') {
      if (d.line1) html += lw105ConfirmRow(template, title + ' 1 ZEILEN', d.line1);
      if (d.sym2) html += lw105ConfirmRow(template, title + ' 2 ZEILE', formatLw105SymbolConfirmValue(d.sym2));
      if (shouldLw105AppendFontAfterSide(sideIndex, zu, d) && fontName) {
        html += lw105ConfirmRow(template, title + ' Font', fontName);
      }
      return html;
    }
    if (d.layout === '1_zeile' && d.line1) {
      html += lw105ConfirmRow(template, title + ' Text', d.line1);
      if (shouldLw105AppendFontAfterSide(sideIndex, zu, d) && fontName) {
        html += lw105ConfirmRow(template, title + ' Font', fontName);
      }
      return html;
    }
    var composed = composeLine(d.line1, d.sym1);
    if (composed) {
      html += lw105ConfirmRow(template, title + ' Text', composed);
      if (shouldLw105AppendFontAfterSide(sideIndex, zu, d) && fontName) {
        html += lw105ConfirmRow(template, title + ' Font', fontName);
      }
    }
    return html;
  }

  function getLw105ColorSwatchMarkup() {
    var title = $('[name="option1"]').attr('data-value') || '';
    var $radio = $('input[data-type="option1"]:checked').filter(function() {
      var t = $(this).attr('data-option-title') || '';
      return !title || t === title;
    }).first();
    if (!$radio.length) {
      $radio = $('input[data-type="option1"]').filter(function() {
        return ($(this).attr('data-option-title') || '') === title;
      }).first();
    }
    var $img = $radio.closest('label, .select_size_form, .product-option-picker').find('img').first();
    if ($img.length && $img.attr('src')) {
      return ' <img class="lw105-confirm-color-img" src="' + esc($img.attr('src')) + '" alt="">';
    }
    var key = String(title).toLowerCase();
    var bg = '#c0c0c0';
    if (key.indexOf('ros') !== -1) bg = '#e8b4b8';
    else if (key.indexOf('gold') !== -1) bg = '#d4af37';
    return ' <span class="lw105-confirm-color-swatch" style="background:' + bg + '"></span>';
  }

  window.lw105EnhanceConfirmOptions = function() {
    var colorValue = $('[name="option1"]').attr('data-value') || '';
    if (colorValue) {
      $('.message-confirm-item .form-in-message').each(function() {
        var $row = $(this);
        if ($row.find('.lw105-confirm-color-swatch, .lw105-confirm-color-img').length) return;
        var text = $.trim($row.text());
        if (text.indexOf(colorValue) === -1) return;
        var $value = $row.find('span').last();
        if ($value.length) $value.append(getLw105ColorSwatchMarkup());
      });
    }

  };

  function scheduleLw105ConfirmEnhance() {
    setTimeout(function() { window.lw105EnhanceConfirmOptions(); }, 0);
    setTimeout(function() { window.lw105EnhanceConfirmOptions(); }, 80);
  }

  window.lw105ConfirmHtml = function(zu, popup_title) {
    var html = '';
    var template = $('#form_message_option2').html() || $('#form_message_option').html();
    if (!template) return '';
    var fontName = getGlobalFont().font_name;

    for (var i = 0; i < zu; i++) {
      var title = getSideLabel(i);
      if (popup_title) {
        var parts = String(popup_title).split(',');
        if (parts[i]) title = $.trim(parts[i]);
      }
      html += buildLw105SideConfirmHtml(template, title, getSideData(i), fontName, i, zu);
    }
    if (html) {
      /* [7] Platzhalter fuer den Vorschau-Streifen — befuellt wird er per
         DOM-Klon NACH dem Einhaengen der Bestaetigungsseite
         (lw105FillConfirmVorschau). */
      html = '<div class="lw105-confirm-vorschau" aria-hidden="true"></div>' + html;
    }
    return html;
  };

  window.lw043ConfirmHtml = window.lw105ConfirmHtml;

  /* [7] Vorschau-Streifen auf der Bestaetigungsseite: klont die live
     gerenderte Buehne aus dem Popup — gleiche Seite, gleiche Styles und
     Schrift, also pixelgleich zum Popup. WICHTIG: beim Bestaetigen ist das
     Popup zu, die Buehne also 0 breit — und weil die Schriftgroessen an
     Container-Queries (cqw) haengen, kaeme ein Klon in diesem Zustand
     verzerrt heraus. Darum vorher unsichtbar messbar machen (fixed,
     -9999px), alle Flaechen aufklappen, frisch rendern, klonen, alles
     zurueckdrehen. */
  function lw105FillConfirmVorschau() {
    var $ziel = $('.message-confirm-item-2 .lw105-confirm-vorschau').last();
    if (!$ziel.length || $ziel.children().length) return;
    var $popup = $('.up-Fenster-p-personalization-1');
    if (!$popup.length) return;

    var altStyle = $popup.attr('style') || '';
    var $zu = lw105AlleSeiten().not('.is-side-open');
    $popup.css({ display: 'block', visibility: 'hidden', position: 'fixed', left: '-9999px', top: '0' });
    $zu.addClass('is-side-open');
    window.lw043UpdatePreview();

    var $stage = $('[data-lw043-preview-stage]').first();
    var sw = $stage.length ? $stage[0].offsetWidth : 0;
    var sh = $stage.length ? $stage[0].offsetHeight : 0;
    if (sw && sh) {
      /* Je gravierte Flaeche EINE Kachel. Beide Plaettchen liegen auf
         DERSELBEN Buehne (ein Foto, zwei Gravur-Ebenen) — eine Doppelkachel
         zeigt jedes Plaettchen darum nur halb so gross, man erkennt nichts
         (Yin 2026-08-16, zuerst auf ae015 behoben). Jetzt wird dieselbe
         Buehne zweimal geklont: je Kachel die fremde Gravur-Ebene raus und
         nur das Fenster um den eigenen Anker gezeigt. */
      var zweiFlaechen = getActiveSideCount() > 1 && !usesFrontOnlyPreviewBase();
      var flaechen = zweiFlaechen
        ? ['front', 'back']
        : [getPhysicalSideIndex(0) === 1 ? 'back' : 'front'];
      var GAP = 8, spalte = $ziel.width() || 320;
      var pro = Math.floor((spalte - GAP * (flaechen.length - 1)) / flaechen.length);
      var ZIEL_B = Math.max(64, Math.min(150, pro));

      flaechen.forEach(function(side) {
        /* Ausschnitt in % der Buehne: der Engel PLUS Rand, nicht ein
           Quadrat um den Gravur-Anker. Ein Quadrat passt zur runden Scheibe
           von ae015, beim hohen Engel schnitt es unten die Oese ab
           (Yin 2026-08-16). Die Kanten stehen in LW105_ENGEL_BOX und sind am
           Basisfoto gemessen, nicht geschaetzt. */
        var box = LW105_ENGEL_BOX[side] || LW105_ENGEL_BOX.front;
        var R = LW105_ENGEL_BOX.rand;
        var fx = Math.max(box.left - R, 0);
        var fy = Math.max(LW105_ENGEL_BOX.top - R, 0);
        var fw = Math.min(box.right + R, 100) - fx;
        var fh = Math.min(LW105_ENGEL_BOX.bottom + R, 100) - fy;

        var $klon = $stage.clone();
        if (zweiFlaechen) {
          // fremde Gravur-Ebene raus, sonst ragt sie ins Fenster
          var fremd = side === 'back' ? 'front' : 'back';
          $klon.find('.lw043-preview-text--' + fremd).remove();
        }

        var fensterPx = sw * fw / 100;
        var f = ZIEL_B / fensterPx;
        var $clip = $('<div class="lw105-cv-clip"></div>').css({
          width: ZIEL_B + 'px',
          height: Math.ceil(sh * fh / 100 * f) + 'px',
          overflow: 'hidden'
        });
        /* erst skalieren, dann in Buehnen-Pixeln verschieben: das translate
           rechnet in den Einheiten VOR der Skalierung. */
        var $scale = $('<div class="lw105-cv-scale"></div>').css({
          width: sw + 'px',
          transform: 'scale(' + f + ') translate(' + (-sw * fx / 100) + 'px,' + (-sh * fy / 100) + 'px)',
          'transform-origin': 'top left'
        });
        $scale.append($klon);
        $clip.append($scale);

        $ziel.append($('<div class="lw105-cv-item"></div>')
          .css('width', ZIEL_B + 'px')
          .append($clip)
          .append('<div class="lw105-cv-name">'
            + esc(side === 'back' ? 'Rückseite' : 'Vorderseite') + '</div>'));
      });
    }

    $zu.removeClass('is-side-open');
    $popup.attr('style', altStyle);
  }

  window.lw105EnhanceConfirmOptions = function() {
    /* laeuft im Event-File VOR dem Einhaengen von .message-confirm-item-2 —
       der Handler dort ist synchron, also reicht ein Tick Verzoegerung. */
    setTimeout(lw105FillConfirmVorschau, 0);
  };

  if (!isEngravingOnlyPopup) {
    $(document).on('change.lw043Geburtsstein', '[name="properies"]', function() {
      if ($('.up-Fenster-p-personalization-1').hasClass('open')) window.lw043UpdatePreview();
    });
  }
  $(document).on('change.lw043Color', '[name="option1"]', function() {
    if ($('.up-Fenster-p-personalization-1').hasClass('open')) window.lw043UpdatePreview();
  });
  $(document).on('change.lw043GravurOption', '[name="option2"]', function() {
    window.lw043GravurConfig = null;
    window.lw100GravurConfig = null;
    window.lwGravurConfig = null;
    if ($('.up-Fenster-p-personalization-1').hasClass('open')) window.lw043UpdatePreview();
  });
  $(document).on('click.lw105ConfirmEnhance', '.up-Fenster-p-personalization-1 .pattles-message-submit-btn', scheduleLw105ConfirmEnhance);
  $(document).on('click.lw105ConfirmEnhance2', '.up-Fenster-p-personalization-2 .pattles-message-submit-btn', scheduleLw105ConfirmEnhance);

  /* ================= LW105 Tuner - aktiviert mit ?lw105tuner=1 =================
     Fuer Kundinnen unsichtbar. Panel seit 2026-08-15 ueber die feste Vorlage
     snippets/tuner-vorlage.liquid (harte Regel 5): Ziehen, DE/中, Export-Box
     und Kontext-Neuaufbau kommen von dort. Hier stehen nur noch die
     Regler-Listen und ihre Verdrahtung in die LW105-Tabellen.
     Vorne und Hinten sind getrennte Regler - Hinten folgt der Vorderseite
     NICHT mehr automatisch. */

  function lw105TunerEnabled() {
    try {
      return /lw105tuner/.test(String(window.location.search) + String(window.location.hash));
    } catch (e) { return false; }
  }

  function lw105TunerSichtbar() {
    var b = document.querySelector('[class*="preview-stage"]');
    if (!b) return false;
    var r = b.getBoundingClientRect();
    return r.width > 0 && r.height > 0
      && r.left < window.innerWidth && r.right > 0
      && r.top < window.innerHeight && r.bottom > 0;
  }

  /* Wie viel Luft ist wirklich zwischen Textzeile und Motivzeile?
     Bewusst NICHT die Zeilenkaesten vergleichen: die Symbol-SVGs haben oben
     viel transparenten Rand (bei Stern 37 von 64 Zeilen), ein Kastenvergleich
     ueberschaetzt die Ueberlappung um etwa das Dreifache. Gemessen wird die
     Unterkante der Schrift-Tinte gegen die erste nicht transparente Pixelzeile
     des Symbols. Wird nur vom Tuner aufgerufen, nie im Kundenpfad. */
  function lw105MeasureClearance() {
    var stage = document.querySelector('[data-lw043-preview-stage]');
    if (!stage) return null;
    var nodes = stage.querySelectorAll('.lw043-preview-text');
    var textEl = null, imgEl = null;
    for (var i = 0; i < nodes.length; i++) {
      var im = nodes[i].querySelector('img');
      if (im) { if (!imgEl) imgEl = im; }
      else if (!textEl && (nodes[i].textContent || '').trim()) textEl = nodes[i];
    }
    if (!textEl || !imgEl || !imgEl.complete) return null;

    var cs = window.getComputedStyle(textEl);
    var ctx = document.createElement('canvas').getContext('2d');
    ctx.font = cs.fontStyle + ' ' + cs.fontWeight + ' ' + cs.fontSize + ' ' + cs.fontFamily;
    var m = ctx.measureText(textEl.textContent || '');
    if (!m || m.actualBoundingBoxDescent == null) return null;

    var tr = textEl.getBoundingClientRect();
    var ir = imgEl.getBoundingClientRect();
    var lh = parseFloat(cs.lineHeight) || parseFloat(cs.fontSize) * 1.15;
    var baseline = tr.top + (lh - (m.fontBoundingBoxAscent + m.fontBoundingBoxDescent)) / 2 +
      m.fontBoundingBoxAscent;
    var inkBottom = baseline + m.actualBoundingBoxDescent;

    var visTop = ir.top, exact = false;
    try {
      var nw = imgEl.naturalWidth, nh = imgEl.naturalHeight;
      if (nw && nh) {
        var cv = document.createElement('canvas');
        cv.width = nw; cv.height = nh;
        var cx = cv.getContext('2d');
        cx.drawImage(imgEl, 0, 0);
        var d = cx.getImageData(0, 0, nw, nh).data;
        var row = -1;
        for (var y = 0; y < nh && row < 0; y++) {
          for (var x = 0; x < nw; x++) {
            if (d[(y * nw + x) * 4 + 3] > 16) { row = y; break; }
          }
        }
        if (row >= 0) { visTop = ir.top + (row / nh) * ir.height; exact = true; }
      }
    } catch (e) {
      /* Bild von fremder Herkunft - dann eben die Bildkante, klar markiert. */
    }
    return { px: visTop - inkBottom, exact: exact };
  }

  var LW105_ANCHOR_GROUPS = [
    { name: '1 Zeile Text', group: function() { return LW105_PREVIEW_1_ZEILE.text; } },
    { name: '2 Zeilen Text', group: function() { return LW105_PREVIEW_2_ZEILEN.text; } },
    { name: '2 Zeilen Motiv', group: function() { return LW105_PREVIEW_2_ZEILEN.icon; } },
    { name: 'Nur Motiv', group: function() { return LW105_PREVIEW_NUR_MOTIV.icon; } }
  ];

  function lw105StatischeItems() {
    var T = LW105_TUNE;
    var items = [
      { h: 'Gesamt' },
      { label: 'Gesamt: Motive ↔ X %', step: 0.1, get: function() { return T.motivDx; }, set: function(v) { T.motivDx = v; } },
      { label: 'Gesamt: Motive ↕ Y %', step: 0.1, get: function() { return T.motivDy; }, set: function(v) { T.motivDy = v; } },
      { label: 'Gesamt: Motiv-Größe ×', step: 0.02, get: function() { return T.motivScale; }, set: function(v) { T.motivScale = v; } }
    ];
    ['front', 'back'].forEach(function(side) {
      items.push({ h: 'Anker Position % - ' + (side === 'back' ? 'Rueckseite' : 'Vorderseite') });
      LW105_ANCHOR_GROUPS.forEach(function(entry) {
        items.push({
          label: entry.name + ' Y', step: 0.1,
          get: function() { return entry.group()[side].top; },
          set: function(n) { entry.group()[side].top = n; }
        });
        items.push({
          label: entry.name + ' X', step: 0.1,
          get: function() { return entry.group()[side].left; },
          set: function(n) { entry.group()[side].left = n; }
        });
      });
    });
    return items;
  }

  function lw105KontextItems() {
    if (!lw105TunerSichtbar()) {
      return [{ h: '\u201EJetzt personalisieren\u201C \u00F6ffnen \u2014 die Vorschau ist zugeklappt' }];
    }
    var items = [];
    var font = lw105CurrentFont();
    var anz = getActiveSideCount();
    for (var i = 0; i < anz; i++) {
      /* Physische Seite, nicht UI-Index: bei "Nur Rueckseite"-Varianten ist
         die einzige UI-Seite (Index 0) physisch die Rueckseite - der Renderer
         schluesselt nach der Klasse --back. Ohne diese Abbildung schrieb der
         Regler nach front, gelesen wurde back: D1 sah live tot aus
         (lw108, 2026-08-15 am echten Produkt erwischt). */
      (function(seite, layout, d) {
        var seiteLabel = seite === 'back' ? 'Hinten' : 'Vorne';

        /* --- Textblock: eigene Groesse und eigene Position, pro Schrift --- */
        if (layout !== 'nur_motiv') {
          items.push({ h: 'TEXT - ' + font + ' / ' + seiteLabel });
          items.push({
            label: 'Groesse x', step: 0.01,
            get: function() { return lw105TextAdj(seite, layout, font).mult; },
            set: function(n) { lw105EnsureTextAdj(seite, layout, font).mult = n; }
          });
          items.push({
            label: 'Position X %', step: 0.1,
            get: function() { return lw105TextAdj(seite, layout, font).dx; },
            set: function(n) { lw105EnsureTextAdj(seite, layout, font).dx = n; }
          });
          items.push({
            label: 'Position Y %', step: 0.1,
            get: function() { return lw105TextAdj(seite, layout, font).dy; },
            set: function(n) { lw105EnsureTextAdj(seite, layout, font).dy = n; }
          });
        }

        /* --- Abstand Text <-> Motiv, nur wenn beides zusammen vorkommt --- */
        if (layout === '2_zeilen') {
          items.push({ h: 'ABSTAND TEXT / MOTIV - ' + font + ' / ' + seiteLabel });
          items.push({
            label: 'Zeilenabstand em', step: 0.05,
            get: function() { return lw105RowGap(seite, font); },
            set: function(n) { lw105EnsureRowGap(seite, font); LW105_ROW_GAP[seite][font] = n; }
          });
        }

        /* --- Motiv: Regler gelten NUR fuer das gerade gewaehlte Symbol.
               Ein anderes Symbol im Popup waehlen laedt dessen eigene Werte. --- */
        var sym = layout === '2_zeilen' ? d.sym2 : (layout === 'nur_motiv' ? d.symOnly : '');
        if (layout !== '1_zeile' && !sym) {
          items.push({ h: 'MOTIV - noch kein Symbol gewaehlt (' + seiteLabel + ')' });
        }
        if (sym) {
          var symKey = lw105SymbolKey(sym);
          items.push({ h: 'MOTIV "' + symKey + '" - ' + seiteLabel });
          items.push({
            label: 'Motiv-Größe', step: 0.01,
            get: function() { return lw105SymbolAdj(seite, layout, sym).size; },
            set: function(n) { lw105EnsureSymbolAdj(seite, layout, sym).size = n; }
          });
          items.push({
            label: 'Motiv ↔ X %', step: 0.1,
            get: function() { return lw105SymbolAdj(seite, layout, sym).dx; },
            set: function(n) { lw105EnsureSymbolAdj(seite, layout, sym).dx = n; }
          });
          items.push({
            label: 'Motiv ↕ Y %', step: 0.1,
            get: function() { return lw105SymbolAdj(seite, layout, sym).dy; },
            set: function(n) { lw105EnsureSymbolAdj(seite, layout, sym).dy = n; }
          });
          if (layout === '2_zeilen') {
            items.push({
              label: 'Abstand (Font×Motiv)', step: 0.02,
              get: function() { return lw105Luft(font, sym); },
              set: function(n) {
                if (!LW105_LUFT_ADJ[font]) LW105_LUFT_ADJ[font] = {};
                LW105_LUFT_ADJ[font][lw105SymbolKey(sym)] = n;
              }
            });
          }
        }
      })(getPhysicalSideIndex(i) === 1 ? 'back' : 'front', getSideLayout(i) || '1_zeile', getSideData(i));
    }
    return items;
  }

  function lw105KontextKey() {
    var teile = [lw105TunerSichtbar() ? 'offen' : 'zu', lw105CurrentFont()];
    var anz = getActiveSideCount();
    for (var i = 0; i < anz; i++) {
      var d = getSideData(i);
      teile.push(getPhysicalSideIndex(i));
      teile.push(d.layout || '');
      teile.push(lw105SymbolKey(d.sym2 || d.symOnly || ''));
    }
    return teile.join('|');
  }

  (window.VivTuner = window.VivTuner || { q: [], refresh: function () {}, register: function () {
    this.q.push(arguments); return { refresh: function () {} };
  } }).register('lw105', {
    titel: 'LW105 Tuner',
    statisch: lw105StatischeItems,
    kontext: lw105KontextItems,
    kontextKey: lw105KontextKey,
    update: function () { if (window.lw043UpdatePreview) window.lw043UpdatePreview(); },
    exportiere: function () {
      return {
        TUNE: LW105_TUNE,
        TEXT_ADJ: LW105_TEXT_ADJ,
        SYMBOL_ADJ: LW105_SYMBOL_ADJ,
        ROW_GAP: LW105_ROW_GAP,
        LUFT_ADJ: LW105_LUFT_ADJ,
        ANKER_1_ZEILE: LW105_PREVIEW_1_ZEILE,
        ANKER_2_ZEILEN: LW105_PREVIEW_2_ZEILEN,
        ANKER_NUR_MOTIV: LW105_PREVIEW_NUR_MOTIV
      };
    }
  });

  /* Luft-Anzeige Text/Motiv: die Messung aus dem alten Panel, jetzt als
     Zusatzkaestchen im Vorlagen-Panel. Gleiches Muster wie das Warnbanner
     unten: von aussen nach .kt-title eingehaengt, die Vorlage selbst bleibt
     generisch. Neu gemessen wird nach jeder Neuzeichnung der Vorschau. */
  if (lw105TunerEnabled()) (function () {
    var geplant = false;
    function zeichneFit() {
      var panel = document.getElementById('lw105-tuner');
      if (!panel) return;
      var box = document.getElementById('lw105-kt-fit');
      if (!box) {
        box = document.createElement('div');
        box.id = 'lw105-kt-fit';
        box.style.cssText = 'display:none;margin:6px 0;padding:5px 7px;' +
          'border-radius:3px;font-size:11px;letter-spacing:.04em';
        var kopf = panel.querySelector('.kt-title');
        if (kopf && kopf.nextSibling) panel.insertBefore(box, kopf.nextSibling);
        else panel.appendChild(box);
      }
      var r = lw105MeasureClearance();
      if (!r) { box.style.display = 'none'; return; }
      var v = Math.round(r.px * 10) / 10;
      var eng = v < 0;
      box.style.display = 'block';
      box.style.background = eng ? '#5a1f1f' : '#1d3d22';
      box.style.color = eng ? '#ffb4b4' : '#b7e4c0';
      box.textContent = (eng ? 'TINTE UEBERLAPPT ' : 'Luft Text/Motiv ') +
        (v > 0 ? '+' : '') + v + ' px' + (r.exact ? '' : ' (nur Bildkante)');
    }
    var beobachter = new MutationObserver(function () {
      if (geplant) return;
      geplant = true;
      window.requestAnimationFrame(function () { geplant = false; zeichneFit(); });
    });
    (function warteAufBuehne() {
      var stage = document.querySelector('[data-lw043-preview-stage]');
      if (!stage) { window.setTimeout(warteAufBuehne, 400); return; }
      beobachter.observe(stage, { childList: true, subtree: true, attributes: true });
      zeichneFit();
    })();
  })();

  /* ---- Wave 0 SS4.4 (2026-08-15): Warnbanner im Reglerfenster, solange die
     Vorschau zugeklappt neben dem Sichtfeld parkt. Hintergrund: das
     Personalisierungsfenster ist immer im DOM und immer display:block —
     zugeklappt steht es nur rechts NEBEN dem Viewport. Die Regler schrieben
     ihre Werte auch dann, die Vorschau aenderte sich auch — nur unsichtbar.
     Yin hat auf as022 einen Nachmittag lang "tote" Regler gesucht, die
     keine waren. Poll statt Hook: die fuenf handgebauten Panels haben
     verschieden geformte Open/Close-Pfade, ein 800-ms-Intervall hinter dem
     URL-Tor ist uniform, billig und kann keinen davon verpassen. */
  if (lw105TunerEnabled()) (function () {
    function vorschauSichtbar() {
      var b = document.querySelector('[class*="preview-stage"]');
      if (!b) return false;
      var r = b.getBoundingClientRect();
      return r.width > 0 && r.height > 0
        && r.left < window.innerWidth && r.right > 0
        && r.top < window.innerHeight && r.bottom > 0;
    }
    setInterval(function () {
      var panel = document.getElementById('lw105-tuner');
      if (!panel) return;
      var h = document.getElementById('lw105-tuner-zu-hinweis');
      if (!h) {
        h = document.createElement('div');
        h.id = 'lw105-tuner-zu-hinweis';
        h.textContent = '\u201EJetzt personalisieren\u201C \u00F6ffnen \u2014 die Vorschau ist zugeklappt; Regler wirken sonst unsichtbar.';
        h.style.cssText = 'display:none;background:#7a2e22;color:#fff;padding:6px 8px;border-radius:4px;margin:4px 0;font-size:11px;line-height:1.35';
        var kopf = panel.querySelector('.kt-title');
        if (kopf && kopf.nextSibling) panel.insertBefore(h, kopf.nextSibling);
        else panel.appendChild(h);
      }
      h.style.display = vorschauSichtbar() ? 'none' : 'block';
    }, 800);
  })();

})(jQuery);
